import React, { Component } from "react";
// import { MDBCol,MDBRow } from 'mdbreact';
import axios from "axios";

import { Menu, Segment, Sidebar } from "semantic-ui-react";
import Chart from "./Chart";
import Sliderbar from "./Sliderbar";
import Sliderbar1 from "./Sliderbar1";
import Select from "react-select"; // For a modern dropdown experience


import PieChart from "./GPieChart";

//import Infotable from "./InfoTable";
import {
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";

import MapView from "./GMapView";

import { Rnd } from "react-rnd";
// import menus from "../Helpers/gmenus";

import domain from "../../domain";
import pagecontent from "../Helpers/GLOFContent";
import AboutModal from "../../GeoportalModal";
import colors from "../../colors";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import Chart_my from "./Chart_my";
library.add(
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight
);

let numClick = 0;

class GMapContainer extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state =  {
      noteclose: false,
      setcriticalboundary:false,
      width: Math.min(600, window.innerWidth * 0.8),
      height:300,
      width1:Math.min(600, window.innerWidth * 0.8),
      height1:300,
      table_width:10,
      table_height:30,
      selectedFactors: [],
      //selectedFactors: ["roads", "bridges", "settlement_points", "settlement_polygon", "Settlement_Names"],
      glofRiskBasins:[],
      glofRiskSubbasins:[],
      glofRiskINBasins:[],
      glofRiskINSubbasins:[],
      selectedFeatures:[],
      // x: 350,
      // y: window.innerHeight - 470,
      x: (window.innerWidth-600-1200)/2,
      y: window.innerHeight - 500,
      x1: (window.innerWidth-270-300)/2,
      y1: window.innerHeight - 500,
      x2: (window.innerWidth-270-10)/2,
      y2: window.innerHeight - 700,
      title: null,
      modal:true,
      collapsed: true,
      collapsed1: true,
      collapsed2:false,
   
      isAllZero: false,
      layer: "Glacial lakes",
      stateInfoStatus: false,
      gllakeInfoStatus:false,
      yaxis: null,
      selectedRegion: "Himalayan Region",
      visibleGraphPanel_pie: false,
      visibleGraphPanel_pie1: false,
      categories: null,
      series: null,
      categories_gl_type: null,
      series_gl_type: null,
      categories_cgl: null,
      series_cgl: null,
      selectedMenu: null,
      boundary: null,
      
      active: true,
      checked: true,
      isInfoOpen:true,
      value: [100, 400],
      value_area:[100,700],
      min_ele: 0,
      max_ele:8000,
      min_area:0.25,
      max_area:3000,
      // selectedMainMenu:"",
      // selectedMaps:null,
      // lastSelected:null,
      india_states_boundary:null,
      velocityChecked: false,
      depthChecked: false,
      roadsChecked: false,
      agricultureChecked: false,
      hydropowerChecked: false,
      bridgesChecked: false,
      settlement_pointsChecked: false,
      settlement_polygonChecked: false,
      inundationChecked: false,
      
    
      rivernames: null,
      cgl_rivernames:null,
      riverselected: "Himalayas",
      basinnames: null,
      basinselected: null,
      subbasinnames: null,
      subbasinselected: null,
      basins: "",
      activeIndex: 0,
      pointInfo: null,
      legend: null,
      selectedLayer: {},
      title_gl_type:null,
      visible: true,
      min:100,
      min_ar:100,
      max:400,
      max_ar:600,
      total:0,
    

      date: "",
      layerExist: true,
      wms_url_default: `${domain.Geoserver}/daily-snow-cover/wms`,
      latlng: { lat: null, lng: null },
      latlngposition: null,
      visibleGraphPanel: false,
      visibleGraphPanel1: false,
 
      availableDates: [],
      selectedNodeStaus: {},
      slideTracker: -1,
      chartData: null,
      onClickDetails: {},
      stateInfo: null,
      gl_lake_boundary:null,
      dateEnabled: false,
      sliderEnabled: false,
      glacial_lakes: null,
      forecast: false,
      geojsona: null,
      himalayan_boundary: null,
      loading: false,
      basininfo: null,
      selectedBaseLayer: null,
      glacial_loading: false,
      technicalnoteenable: false,
      disclaimerenable: false,
      categories_cgl: null,
      series_cgl: null,
      glofriskassesmentselected:"#",

      criticalfeatureSelected:"#",
  
      categories_gl_type_cgl: null,
      series_gl_type_cgl: null,
      
      critical_glacial_lake_boundary:null,
      critical_glacial_lake_boundaryall:null,
      glofriskinundation:'#',
      criticalglaciallakeselected:'cgl_all',
      criticalRiskBasinSelected:'#',
      criticalIndSimBasinSelected:'#',
      criticalIndSimLakeSelected:'#',
      criticalRiskLakeSelected:"#",
      criticalIndSimScenarioSelected:'#',
      criticalIndSimScenarioSelectedRisk:'#',
      critical_gl_lake_boundary_status:false,
      criticalFactorSelected:'#',
      legend_SimScenario:null,
      InudationLakeSimBoundary:null,
      glofRiskLakeBoundary:null,
      criticalInudationBasinboundary:null,
      criticalRiskBasinboundary:null,

      
    };
  };
  closeInfo = () => {
    // Set the state to close the message box
    this.setState({ isInfoOpen:false });
  };
 
  scale = (value) => {
    if (value === undefined) {
      return undefined;
    } else if (value === 100) {
      return "<"+3000;
    } else if (value === 200) {
      return 4000;
    } else if (value === 300) {
      return 5000;
    } else if (value === 400) {
      return ( ">"+6000)
    }
  };

  scaleValues = (valueArray) => {
    let a = "#";
    let b = "#";

      a = this.scale(valueArray[0]);
      b = this.scale(valueArray[1]);

      if (a > 0 && b > 0) {
        console.log("if", a, b);
       
      }
      
    return [this.scale(valueArray[0]), this.scale(valueArray[1])];
  };
  

  handleChangeValue = (event, newValue) => {
    let min_ele,max_ele;
    
   
    min_ele=this.updateValueElevation(event.target.value[0])
    max_ele=this.updateValueElevation(event.target.value[1])
    if(min_ele===3000 && max_ele===6000)
    {
      console.log("this cond min_ele===3000 && max_ele===6000 ")
      min_ele=0
      max_ele=8000
    }
    else{
      if(min_ele===3000 && max_ele!==3000)
        {
          console.log("this cond min_ele===3000 && max_ele!==3000 ")
      min_ele=0
    }

      
    
   
       else if (min_ele===3000 && max_ele===3000){
        min_ele=0
        max_ele=3000
        console.log("this cond min_ele===3000 && max_ele===3000")
    }
    else if(max_ele===6000 && min_ele!==6000)
    {
      max_ele=8000
      console.log("this cond max_ele===6000 && min_ele!==6000")
    }
    else if(max_ele===6000 && min_ele===6000)
    {
      min_ele=6000
      max_ele=8000
      console.log("this cond max_ele===6000 && min_ele===6000")
    }
  }

    this.setState({min_ele:min_ele, max_ele:max_ele})
    if((this.state.riverselected==="Himalayas") && (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===false)&&(this.state.collapsed===true))  {
      this.getBaseLayer_boundary()
      console.log("basin not selected")
    //this.updateValueArea()
    this.getDefaultGLCount(min_ele,max_ele,this.state.min_area,this.state.max_area);
    console.log("aadefault  ele",this.state.min_area,this.state.max_area,min_ele,max_ele)


    
    }else if ( (this.state.riverselected==="Himalayas")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===true)&&(this.state.collapsed===false))

    {
     this.handleCGLall(min_ele,max_ele,this.state.min_area,this.state.max_area)

    }
    else if ( (this.state.riverselected==="Himalayas")&& (this.state.criticalglaciallakeselected!=="cgl_all")&&(this.state.collapsed2===true)&&(this.state.collapsed===false))

    {
     this.handleCGL(this.state.criticalglaciallakeselected,min_ele,max_ele,this.state.min_area,this.state.max_area)

    }
    else
    {
      if((this.state.riverselected!=="Himalayas")&&(this.state.basinselected==="#")&&(this.state.subbasinselected==="#")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===false)&&(this.state.collapsed===true))
      {
        console.log("aaariverselected",this.state.basinselected,this.state.riverselected,this.state.subbasinselected)
        this.getRiverStats(this.state.riverselected,min_ele,max_ele,this.state.min_area,this.state.max_area)
        
      }
      else if ((this.state.riverselected!=="Himalayas")&&(this.state.basinselected!=="#")&&(this.state.subbasinselected==="#")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===false)&&(this.state.collapsed===true))

      {
        this.basinStats(this.state.basinselected,min_ele,max_ele,this.state.min_area,this.state.max_area)

        console.log("aaabasinseleected",this.state.basinselected,this.state.riverselected,this.state.subbasinselected)
      }
      else if ((this.state.riverselected!=="Himalayas")&&(this.state.basinselected!=="#")&&(this.state.subbasinselected!=="#")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===false)&&(this.state.collapsed===true))
      {

        this.subbasinStats(this.state.subbasinselected,min_ele,max_ele,this.state.min_area,this.state.max_area)
        console.log("aaasubbasin selected",this.state.basinselected,this.state.riverselected,this.state.subbasinselected)
      }
    }

    this.setState({ value: event.target.value})

  };
  scale_area = (value) => {
    if (value === undefined) {
      return undefined;
    } else if (value === 100) {
      return 0.25;
    } else if (value === 200) {
      return 0.5;
    } else if (value === 300) {
      return 1;
    } else if (value === 400) {
      return 5;
    } else if (value === 500) {
      return 10;
    } else if (value === 600) {
      return ">"+50
    } 
   
  };

  scaleValues_area = (valueArray) => {

    return [this.scale_area(valueArray[0]), this.scale_area(valueArray[1])]
  };
  handleChange_area = (event, newValue) => {
    let min_area,max_area;
    console.log("before event.target.value",event.target.value)
    min_area=this.updateValueArea(event.target.value[0])
    max_area=this.updateValueArea(event.target.value[1])

    if(min_area===0.25 && max_area===50)
    {
      console.log("this cond min_area===3000 && max_area===6000 ")
      min_area=0.25
      max_area=3000
    }
    else{
      if(min_area===0.25 && max_area!==0.25)
        {
          console.log("this cond min_area===3000 && max_area!==3000 ")
      min_area=0.25
    }

      
    
   
       else if (min_area===0.25 && max_area===0.25){
        min_area=0.25
        max_area=0.25
        console.log("this cond min_area===0.25 && max_area===0.25")
    }
    else if(max_area===50 && min_area!==50)
    {
      max_area=3000
      console.log("this cond max_area===50 && min_area!==50")
    }
    else if(max_area===50 && min_area===50)
    {
      min_area=50
      max_area=3000
      console.log("this cond max_area===50 && min_area===50")
    }
  }

    this.setState({min_area:min_area, max_area:max_area,stateInfo:null})
    if((this.state.riverselected==="Himalayas")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===false)&&(this.state.collapsed===true)){
      this.getBaseLayer_boundary()
      console.log("aaahimalayas",this.state.basinselected,this.state.riverselected,this.state.subbasinselected)
    
          this.getDefaultGLCount(this.state.min_ele,this.state.max_ele,min_area,max_area)
          console.log("aadefault  change area",min_area,max_area,this.state.min_ele,this.state.max_ele)

    }
    else if ( (this.state.riverselected==="Himalayas")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===true)&&(this.state.collapsed===false))

    {
     this.handleCGLall(this.state.min_ele,this.state.max_ele,min_area,max_area)

    }
    else if ( (this.state.riverselected==="Himalayas")&& (this.state.criticalglaciallakeselected!=="cgl_all")&&(this.state.collapsed2===true)&& (this.state.collapsed===false))

    {
     this.handleCGL(this.state.criticalglaciallakeselected,this.state.min_ele,this.state.max_ele,min_area,max_area)

    }
    
    else
    {
      if((this.state.riverselected!=="Himalayas")&&(this.state.basinselected==="#")&&(this.state.subbasinselected==="#")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===false)&&(this.state.collapsed===true))
      {
        console.log("aaariverselected",this.state.basinselected,this.state.riverselected,this.state.subbasinselected)
        this.getRiverStats(this.state.riverselected,this.state.min_ele,this.state.max_ele,min_area,max_area)
        
      }
      else if ((this.state.basinselected!=="#")&&(this.state.subbasinselected==="#")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===false)&&(this.state.collapsed===true))

      {
        this.basinStats(this.state.basinselected,this.state.min_ele,this.state.max_ele,min_area,max_area)

        console.log("aaabasinseleected",this.state.basinselected,this.state.riverselected,this.state.subbasinselected)
      }
      else if ((this.state.basinselected!=="#")&&(this.state.subbasinselected!=="#")&& (this.state.criticalglaciallakeselected==="cgl_all")&&(this.state.collapsed2===false)&&(this.state.collapsed===true)) 
      {

        this.subbasinStats(this.state.subbasinselected,this.state.min_ele,this.state.max_ele,min_area,max_area)
        console.log("aaasubbasin selected",this.state.basinselected,this.state.riverselected,this.state.subbasinselected)
      }
    }

    this.setState({ value_area: event.target.value,stateInfo:null});
    
  };

  handleGlofRiskInundation = (event) => {
    this.setState({
      glofriskinundation: event.target.value,
      //selectedFactors:[],
      selectedFeatures:[],
      selectedFactors:[this.state.criticalIndSimLakeSelected+"_roads",this.state.criticalIndSimLakeSelected+"_bridges",this.state.criticalIndSimLakeSelected+"_settlement_polygon",this.state.criticalIndSimLakeSelected+"_settlement_points",this.state.criticalIndSimLakeSelected+"_agriculture"],

      criticalIndSimScenarioSelected:'#',
      criticalIndSimScenarioSelectedRisk:'#',
      velocityChecked:false,
      depthChecked:false,

      criticalFeatureSelected:"#",
      roadsChecked:true,
      bridgesChecked:true,
      settlement_pointsChecked:true,
      settlement_polygonChecked:true,
      agricultureChecked:true,


    });
    console.log("glofriskass", event.target.value)
  };
  handleGlofRiskAssessmentChange = (event) => {
    console.log("crrrrrrrrr",event.target.value)
    this.getBaseLayer_boundary()
    this.setState({
      boundary:null,
      selectedFactors:[],
      selectedFeatures:[],
      roadsChecked:false,
      bridgesChecked:false,
      agricultureChecked:false,
      settlement_pointsChecked:false,
      settlement_polygonChecked:false,
      hydropowerChecked:false,

      

  
      
    })
    
    if(event.target.value!=="cgl"){
      axios.get(`${domain.DBServer}/get-glof-risk-basins`).then((result) => {
        if (result) {
          this.setState({
            glofRiskBasins: result.data,
          });
        }
        console.log("result.data",result.data)
      });

    this.setState({
      glofriskassesmentselected: event.target.value,
      series_cgl:null,
      categories_cgl:null,
      series:null,
      categories:null,
      glofriskinundation:'#',
 
      critical_glacial_lake_boundary:null,
      critical_glacial_lake_boundaryall:null,
      criticalIndSimScenarioSelected:'#',
      criticalIndSimScenarioSelectedRisk:'#',
      selectedFeatures:[],
      selectedFactors:[],
      criticalRiskBasinSelected:'#',
      criticalIndSimBasinSelected:'#',
      criticalIndSimLakeSelected:'#',
      criticalRiskLakeSelected:"#",
      legend_SimScenario:null,

      boundary:null,
      roadsChecked: false,
      agricultureChecked: false,
      hydropowerChecked: false,
      bridgesChecked: false,
      settlement_pointsChecked: false,
      settlement_polygonChecked: false,
      
    });
  }
  else{
    let min_ele= 0,
    max_ele=8000,
    min_area=0.25,
    max_area=3000;
    console.log("min_ele,max_ele,min_area,max_area",min_ele,max_ele,min_area,max_area)
    this.handleCGLall(min_ele,max_ele,min_area,max_area)

    this.setState({
      glofriskassesmentselected: event.target.value,
      criticalIndSimLakeSelected:'#',
      criticalIndSimBasinSelected:'#',
      criticalIndSimScenarioSelected:'#',
      criticalIndSimScenarioSelectedRisk:'#',
      selectedFeatures:[],
      legend_SimScenario:null,
      selectedFactors:[],
      boundary:null,
      
    });

  }
    console.log("glofriskass", event.target.value)
  };
  setGeojson = (geojsona) => {
    this.setState({
      geojsona: geojsona,
    });
  };
  getIndiaStatesBoundary = () => {
    axios.post(`${domain.DBServer}/get-india-states-boundary`).then((result) => {
      if (result) {
        this.setState({
          india_states_boundary: result.data[0].india_boundary,
        });
      }
    });
  };

  handleCGLall=(min_ele,max_ele,min_area,max_area) => {

    let categories_cgl=[],
    categories:[],
    totalcount = 0,
    categories_gl_type_cgl=[],
    series_gl_type_cgl=[],
    series_cgl=[];


    axios.get(`${domain.DBServer}/fetch-criticalglaciallakesjsonall/${min_ele}/${max_ele}/${min_area}/${max_area}`).then((result) => {
      if (result) {
        console.log("jjjjjjjjjjjsonall",result.data[0].basin_boundary)

        this.setCriticalGlacialLakeBoundaryall(result.data[0].basin_boundary)
      
        
      }
      else{
        console.log("jjjjjjjjjjjsonall",result.data[0].basin_boundary)

        this.setCriticalGlacialLakeBoundaryall(null)
      
      }
    
    });

    
    axios.get(`${domain.DBServer}/fetch-criticalglaciallakesstat/${min_ele}/${max_ele}/${min_area}/${max_area}`).then((result) => {
      if (result) {
        console.log(result,";;;;;;;;;;;;;;;",result.data.data1)
        result.data.data1.map((result) => {

          categories_cgl.push(result.basin.split(" "));
          return true;
        });
        result.data.data1.map((result) => {
          series_cgl.push(Number(result.count).toFixed());
          totalcount = totalcount + Number(result.count);
          return true;
        });

        result.data.data2.map((result) => {
          let gl_type_cgl=result.gl_type
          
         
          categories_gl_type_cgl.push(gl_type_cgl);
        });
    
        result.data.data2.map((result) => {
          console.log("result data2",result.count)
          series_gl_type_cgl.push(Number(result.count));
          //totalcount = totalcount + Number(result.count);
          return true;
        });

        

      }
       // console.log(series);
        this.setState({
          visibleGraphPanel_pie: true,
          visibleGraphPanel_pie1: true,

          categories: categories_cgl,
          categories_gl_type: null,

          xaxis: "River System",
          title: [`Selected Glacial Lakes in Himalayas - (${Number(
            totalcount
          ).toLocaleString("en-IN")})`, ("(Only 5-most Selected Glacial Lakes shown in each Basin)").toLowerCase()],
          yaxis: "No. of Selected Glaical Lakes",
          series: series_cgl,
          series_gl_type:null,
          total:totalcount,
          units: "",
          title_gl_type: `Selected Glacial Lakes Type Distribution in Himalayas`,
          visible:window.innerWidth>1000?true:false,
         
        });   
       
      
     } );
    

  }

  handleCGL=(value,min_ele,max_ele,min_area,max_area) => {
    let categories_cgl=[],
    totalcount = 0,
    categories_gl_type_cgl=[],
    series_gl_type_cgl=[],
    series_cgl=[];

  {/*
    axios.get(`${domain.DBServer}/fetch-criticalglaciallakestat/${value}/${min_ele}/${max_ele}/${min_area}/${max_area}`).then((result) => {
      if (result) {
        console.log(result,"critial statis;;;",result.data.data1)
        result.data.data1.map((result) => {

          categories_cgl.push(result.basin);
          return true;
        });
        result.data.data1.map((result) => {
          series_cgl.push(Number(result.count).toFixed());
          totalcount = totalcount + Number(result.count);
          return true;
        });

        result.data.data2.map((result) => {
          let gl_type_cgl=result.gl_type
          
         
          categories_gl_type_cgl.push(gl_type_cgl);
        });
    
        result.data.data2.map((result) => {
          console.log("result data2",result.count)
          series_gl_type_cgl.push(Number(result.count));
          //totalcount = totalcount + Number(result.count);
          return true;
        });

        

      }
       // console.log(series);
        this.setState({
          visibleGraphPanel_pie: true,
          visibleGraphPanel_pie1: true,

          categories: categories_cgl,
          categories_gl_type: null,

          xaxis: "River System",
          title: `Critical Glacial Lakes in ${value}- (${Number(
            totalcount
          ).toLocaleString("en-IN")})`,
          yaxis: "No. of Critical Glaical Lakes",
          series: series_cgl,
          series_gl_type:null,
          total:totalcount,
          units: "",
          title_gl_type: `Critical Glacial Lakes Type Distribution in Himalayas`,
          visible:window.innerWidth>1000?true:false,
          stateInfo:null
        });   
       
      
     } );*/}
    axios.get(`${domain.DBServer}/fetch-criticalglaciallakesjson/${value}/${min_ele}/${max_ele}/${min_area}/${max_area}`).then((result) => {
      if (result) {
        console.log("crit json",result.data[0].basin_boundary)

      
        this.setState({
          critical_glacial_lake_boundary:result.data[0].basin_boundary,
         // layer:null,
          loading:true,
        })
        this.setCriticalGlacialLakeBoundary(result.data[0].basin_boundary)
      
        
      }
      else
      {
        this.setState({critical_glacial_lake_boundary:null})
      }
    });
   

  }

  toggleVisibleGraphPanel = () => {
    this.setState({
      visibleGraphPanel: !this.state.visibleGraphPanel,
    });
  };

  toggleVisibleGraphPanel1 = () => {
    this.setState({
      visibleGraphPanel1: !this.state.visibleGraphPanel1,
    });
  };
  toggleVisibleGraphPanel_pie = () => {
    this.setState({
      visibleGraphPanel_pie: !this.state.visibleGraphPanel_pie,
    });
  };
  toggleVisibleGraphPanel_pie1 = () => {
    this.setState({
      visibleGraphPanel_pie1: !this.state.visibleGraphPanel_pie1,
    });
  };


  handleVisibleGraphPanelOnMapClick = () => {
    this.setState({
      visibleGraphPanel: true,
      visibleGraphPanel1:true,
    });
  };
  onUpdateBasin = (result) => {
    console.log(result);
    this.setState({
      basininfo: result,
    });
  };

 
   updateValueElevation= (value) => {
  
    console.log(this.state.value[0],",,,,,,,,,,,,,,,,,,,,,,,,,",value);
    let temp=value
    console.log(temp,"temp")


   
    if (temp==100)
    {
      return 3000;  
    }
    else if(temp==200)
  {
    return 4000;
  }
  else if(temp==300)
  {
    return 5000;
  }
    else if(temp==400)
  {
    return 6000;
  }
 
  

    this.setState({
    min_max_ele: [this.state.min_ele,this.state.max_ele],
    critical_glacial_lake_boundary:null});
    console.log("code",temp,this.state.min_ele,this.state.max_ele)
  };

  updateValueArea= (value) => {
  
    console.log(this.state.value_area[0],",,,,,,,,,,,,,,,,,,,,,,,,,",value);
    let temp=value
    if (temp==100)
    {
      return 0.25;
      
    }
    else if(temp==200)
  {
    return 0.5;

  }
  else if(temp==300)
  {
    return 1;
  }
    else if(temp==400)
  {
    return 5;
  }
  else if(temp==500)
  {
  return 10;          
  }  
  else if(temp==600)
  {
    return 50;
  }
  else if(temp==700)
  {
   return 100;   
  }
  

    
    console.log("codeee",temp,this.state.min_area,this.state.max_area)
  };

  toggleSelectedNodeStatus = (menu) => {
    let selectedNodeStaus = { ...this.state.selectedNodeStatus };

    selectedNodeStaus[menu] = !selectedNodeStaus[menu];

    this.setState({
      selectedNodeStaus: selectedNodeStaus,
      //  wms_url_default:wms_url
    });
    //   this.getAvailableDates_url(wms_url)
    //this.getAvailableDates(wms_url)
  };

  enableDatePicker = (status) => {
    this.setState({
      dateEnabled: status,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  enableSlider = (status) => {
    this.setState({
      sliderEnabled: status,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };
  enableForecast = (status) => {
    this.setState({
      forecast: status,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  handleAnimationChange = () => {
    this.setState({
      visible: !this.state.visible,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  setSelectedMenu = (menu) => {
    if (menu === "River") {
      menu = "river_network";
    }
    // else if(main==='Glaciers')
    // {
    //     main='Glaciers_lakes'
    // }
    this.setState({
      selectedMenu: menu,
      // lastSelected: menu
    });
  };
  // getGlaciallakes=()=>
  // {
  //     this.setState({glacial_loading:true})
  //     // console.log('here')
  //     axios.get(`${domain.DBServer}/get-glacial-lakes`).then((result)=>{
  //         if(result)
  //         {
  //                 this.setState({
  //                    glacial_lakes: (result.data[0].glacial_lakes),
  //                    glacial_loading:false
  //                 })
  //         }
  //     })
  // }

  setSelectedLayer = (main) => {
    console.log(main);

    //   let selectedLayer={...this.state.selectedLayer}
    //  if(main==='Glacial Lakes')
    //  {
    //     this.getGlaciallakes()
    //  }
    if (main === "River") {
      main = "river_network";
    } else if (main === "Glaciers") {
      main = "Glaciers_lakes";
    }

    console.log(main);

    this.setState({
      selectedLayer: main,
      // selectedMaps:selectedMaps
    });
  };

  setSelectedBaseLayer = (main) => {
    console.log(main);

    // let selectedLayer={...this.state.selectedLayer}
    if (main === "Basin") {
      main = "basins";
    } else if (main === "LULC") {
      main = "LULC";
    }

    this.setState({
      selectedBaseLayer: main,
      // selectedMaps:selectedMaps
    });
  };

  setStateInfo = (info) => {
    this.setState({
      stateInfo: info,
      stateInfoStatus: false,
      isInfoOpen:true,
    });
  };
  setGLLakeBoundary=(info)=> {
    console.log("infooooooooo",info.features)
    if(info.features!==null){
      this.setState({

        value:[100,400],
        value_area:[100,600],
        min_ele: 0,
        max_ele:8000,
        min_area:0.25,
        max_area:3000,
        min:100,
        min_ar:100,
        max:400,
        max_ar:600,
      //boundary:info,
      gl_lake_boundary:info,
      
   
     
      gllakeInfoStatus: false,
      visibleGraphPanel_pie:false,
      visibleGraphPanel_pie1:false,

      series: null,
      series_gl_type: null,
      setcriticalboundary:false,
      critical_glacial_lake_boundary:null,

      criticalglaciallakeselected:"cgl_all",

    })
  }
  }

  setLegend = (src) => {
    this.setState({
      legend: src,
    });
  };

  setLatLng = (latlng) => {
    this.setState({
      latlng: latlng,
    });
  };

  setOnClickDetails = (data) => {
    this.setState({
      onClickDetails: data,
    });
  };
  onClick = () => {
    this.setState({
      active: !this.state.active,
    });
  };

  async doesLayerExist(layer, wms_url) {
    let result = await axios.get(wms_url, {
      params: {
        request: "DescribeLayer",
        service: "WMS",
        srs: "EPSG:4326",
        version: "1.1.1",
        layers: layer,
        output_format: "application/json",
        exceptions: "application/vnd.ogc.se_xml",

        // propertyNames:property
      },
      // headers: {"Access-Control-Allow-Origin": "*"},
      withCredentials: true,
    });
    // console.log(result.data.layerDescriptions)

    if (result.data.layerDescriptions !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  async describeLayer(layer, wms_url) {
    let result = await axios.get(wms_url, {
      params: {
        request: "DescribeLayer",
        service: "WMS",
        srs: "EPSG:4326",
        version: "1.1.1",
        layers: layer,
        output_format: "application/json",
        exceptions: "application/vnd.ogc.se_xml",
        // propertyNames:property
      },
      // headers: {"Access-Control-Allow-Origin": "*"},
      withCredentials: true,
    });
    // console.log(result.data.layerDescriptions)

    return result.data;
  }

  async getFeatureInfo(layer, wms_url, x, y, height, width, bbox) {
    let result = await axios.get(wms_url, {
      params: {
        request: "GetFeatureInfo",
        service: "WMS",
        srs: "EPSG:4326",
        version: "1.1.1",
        bbox: bbox,
        x: Math.round(x),
        y: Math.round(y),
        height: Math.round(height),
        width: Math.round(width),
        layers: layer,
        query_layers: layer,
        info_format: "application/json",
        exceptions: "application/vnd.ogc.se_xml",
        buffer: 0,
        // cql_filter:`INTERSECTS(POLYGON(${bbox}),POINT(${latlng.lat} ${latlng.lon}))`,
        // propertyNames:'the_geom'
      },
      // headers: {"Access-Control-Allow-Origin": "*"},
      withCredentials: true,
    });

    return new Promise((resolve) => {
      resolve(result);
    });
    // return result
  }

  getBaseLayer = () => {
    axios.get(`${domain.DBServer}/get-himalayan-boundary`).then((result) => {
      if (result) {
        this.setState({
          himalayan_boundary: result.data[0].himalayan_boundary,
          // boundary: result.data[0].himalayan_boundary,
          loading: true,
        });
      }
    });
  };

  getBaseLayer_boundary = () => {
    axios.get(`${domain.DBServer}/get-himalayan-boundary`).then((result) => {
      if (result) {
        this.setState({
          boundary: result.data[0].himalayan_boundary,
          // boundary: result.data[0].himalayan_boundary,
          loading: true,
        });
      }
    });
  };
  getRiverSystemNames = () => {
    axios.get(`${domain.DBServer}/fetch-basins`).then((result) => {
      if (result) {
        console.log(result);
        this.setState({
          rivernames: result.data,
        });
      }
    });
  };

  getCriticalGlacialLakes = () => {
    axios.get(`${domain.DBServer}/fetch-criticalglaciallakes `).then((result) => {
      if (result) {
        console.log(result);
        this.setState({
          cgl_rivernames: result.data,   
        });  
      }
    });
  };



  // async getFeatureInfo(wms_url) {F
  //   let result = await axios.get(wms_url);

  //   return new Promise(resolve => {
  //     resolve(result);
  //   });
  // }
  getDefaultGLCount = (min_el,max_el,min_are,max_are) => {

    console.log("default,",min_el,max_el,min_are,max_are)
    this.setState({
      //value:[100,600],
      //value_area:[100,800],
      stateInfo:null,
      setcriticalboundary:false,

      criticalglaciallakeselected:"cgl_all",
      categories_cgl: null,
      series_cgl: null,
      glofriskassesmentselected:"#",

      criticalfeatureSelected:"#",
      criticalIndSimBasinSelected:'#',
      criticalIndSimLakeSelected:'#',
      categories_gl_type_cgl: null,
      series_gl_type_cgl: null,
      
      critical_glacial_lake_boundary:null,
      critical_glacial_lake_boundaryall:null,
      glofriskinundation:'#',
      criticalglaciallakeselected:'cgl_all',
      criticalRiskBasinSelected:'#',
      criticalRiskLakeSelected:"#",
      criticalIndSimScenarioSelected:'#',
      criticalIndSimScenarioSelectedRisk:'#',
      critical_gl_lake_boundary_status:false,
      criticalFactorSelected:'#',
      legend_SimScenario:null,
      



      
      
})
let categories = [];
let min_ele=min_el;
let max_ele=max_el;
let min_area=min_are;
let max_area=max_are;
let series = [];
let categories_gl_type=[];
let series_gl_type= [];
let totalcount = 0;

//let value=this.state.value
//let value_area=this.state.value_area
   //this.updateValueElevation(value)
   //this.updateValueArea(value_area)
//console.log(value, "ele.....",this.state.min_ele,this.state.max_ele,"\n", value_area,"area fun",this.state.min_area,this.state.max_area)

    if( this.state.value[0] ==100 && this.state.value[1]==100 ){

      this.setState({
        min_ele:0,
        max_ele:3000
      })
    }
    if( this.state.value[0] ==600 && this.state.value[1]==600 ){
      console.log("yes",this.state.value[0], this.state.value[1])
      this.setState({
        min_ele:6000,
        max_ele:8000
      })
    }
      if( this.state.min_area==0.25 && this.state.max_area==0.25 ){
        this.setState({
          min_area:0
        })

    }

    if( this.state.value_area[0]==800 && this.state.value_area[1]==800 ){
      this.setState({
        min_area:100,
        max_area:3000
      })
    }
     

    axios.get(`${domain.DBServer}/get-glof-total-count-2023/${min_ele}/${max_ele}/${min_area}/${max_area}`).then((result) => {
      if (result) {
        console.log(result,";;;;;;;;;;;;;;;",result.data.data1)
        result.data.data1.map((result) => {

          let basin=result.basin

          console.log("basinnnnnn",basin)
          if(basin=='Brahmaputra')
          {
            basin='Brahmaputra'
          }
          categories.push(basin);
          return true;
        });
        result.data.data1.map((result) => {
          series.push(Number(result.count).toFixed());
          totalcount = totalcount + Number(result.count);
          return true;
        });

        result.data.data2.map((result) => {
          let gl_type=result.gl_type
          console.log("gl_type",gl_type)
         
          categories_gl_type.push(gl_type);
        });
    
        result.data.data2.map((result) => {
          console.log("result data2",result.count)
          series_gl_type.push(Number(result.count));
          //totalcount = totalcount + Number(result.count);
          return true;
        });

        console.log("seriesssssss",series,totalcount,categories)
        console.log("seriessssgl_type",series_gl_type,totalcount,categories_gl_type)


       // console.log(series);
        this.setState({
          visibleGraphPanel_pie: true,
          visibleGraphPanel_pie1: true,

          categories: categories,
          categories_gl_type: categories_gl_type,

          xaxis: "River System",
          title: `Glacial Lakes in Himalayas - (${Number(
            totalcount
          ).toLocaleString("en-IN")})`,
          yaxis: "No. of Glaical Lakes",
          series: series,
          series_gl_type,
          total:totalcount,
          units: "",
          title_gl_type: `Glacial Lakes Type Distribution in Himalayas`,
          visible:window.innerWidth>1000?true:false,
          stateInfo:null
        });   
       
      
      }
    });
  };
  componentDidMount() {''
    this.getBaseLayer();
    this.getIndiaStatesBoundary();
    this.getRiverSystemNames();
    this.getCriticalGlacialLakes();
    this.getDefaultGLCount(this.state.min_ele,this.state.max_ele,this.state.min_area,this.state.max_area);
    //this.getCriticalGlacialLakesJson();
    console.log(this._menuBlock.clientHeight);
    if(window.innerWidth <1025)
    {
      this.setState({
        visible:false,
        legendVisible:false,
        x:0,
        y:0,
        width:300,
        height:300

      })
    }
    // this.setState({
    //   x: 350,
    //   y: this._menuBlock.clientHeight - 300,
    // });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidUpdate(prevProps, prevState) { 
    if (prevState.criticalIndSimScenarioSelected !== this.state.criticalIndSimScenarioSelected) {
    this.setState({
      velocityChecked: false,
      depthChecked: true,
      inundationChecked: false,
    });

    if ((prevState.criticalIndSimBasinSelected !== this.state.criticalIndSimBasinSelected) || (prevState.criticalIndSimLakeSelected !== this.state.criticalIndSimLakeSelected)||(prevState.criticalRiskBasinSelected!==this.state.criticalRiskBasinSelected)||(prevState.criticalRiskLakeSelected!==this.state.criticalRiskLakeSelected)) {
      this.setState({
        roadsChecked: false,
        agricultureChecked: false,
        hydropowerChecked: false,
        bridgesChecked: false,
        settlement_pointsChecked: false,
        settlement_polygonChecked: false,
      });
    }
  }


}
  handleHideClick = () => this.setState({ visible: false });
  handleShowClick = () => this.setState({ visible: true });
  handleSidebarHide = () => this.setState({ visible: false });
  
  GlacialCheck = () => {
 
   let min_ele=0,
    max_ele=8000,
    min_area=0.25,
    max_area=3000;
    this.setState({
      collapsed: !this.state.collapsed,
      collapsed2: false,
      criticalglaciallakeselected:"cgl_all",
      glofriskassesmentselected:'#',
      critical_glacial_lake_boundary:null,
      critical_glacial_lake_boundaryall:null,
      layer:this.state.layer,
      riverselected: "Himalayas",
      himalayan_boundary:this.state.himalayan_boundary,
      value:[100,400],
      value_area:[100,600],
      min_ele: 0,
      max_ele:8000,
      min_area:0.25,
      max_area:3000,
      min:100,
      min_ar:100,
      max:400,
      max_ar:600,
      
       boundary:null,
       selectedFactors:[],
       selectedFeatures:[],
       roadsChecked: false,
       agricultureChecked: false,
       hydropowerChecked: false,
       bridgesChecked: false,
       settlement_pointsChecked: false,
       settlement_polygonChecked: false,
       

    
    });
    //this.getIndiaStatesBoundary()
    this.getBaseLayer_boundary()
    this.getDefaultGLCount(min_ele,max_ele,min_area,max_area)
  };
  GLRCheck=() => {
    this.setState({
      collapsed1: !this.state.collapsed1,
      //series:null,
     // series_gl_type:null,
    });

  };
  GLRAssessment=() => {

    this.setState({
      collapsed2: !this.state.collapsed2,
      series:null,
      categories:null,
      isAllZero:false,
      //collapsed1: !this.state.collapsed1,
      value:[100,400],
      value_area:[100,600],
      min_ele: 0,
      max_ele:8000,
      min_area:0.25,
      max_area:3000,
      min:100,
      min_ar:100,
      max:400,
      max_ar:600,
      collapsed:false,
      layer:this.state.layer,
      riverselected: "Himalayas",
      himalayan_boundary:this.state.himalayan_boundary,

      
      critical_glacial_lake_boundary:null,
      critical_glacial_lake_boundaryall:null,
      //categories_gl_type:null,
      criticalglaciallakeselected:"cgl_all",
      glofriskassesmentselected:'cgl',
      boundary:null,
      

    });
    let min_ele= 0,
    max_ele=8000,
    min_area=0.25,
    max_area=3000;
    console.log("min_ele,max_ele,min_area,max_area",min_ele,max_ele,min_area,max_area)
    this.handleCGLall(min_ele,max_ele,min_area,max_area)
    if(this.state.glofriskassesmentselected === "cgl" )
    { 
      console.log("glofriskassesmentselected selected")
      this.handleCGLall(min_ele,max_ele,min_area,max_area)
    }
    

  };
  getRiverStats = (river,min_el,max_el,min_are,max_are) => {

 

    axios
      .get(`${domain.DBServer}/get-himalayan-basin/${river}`)
      .then((result) => {
        if (result) {
          console.log(result);
          this.setState({
            boundary: result.data[0].basin_boundary,
          });
        }
      });
    axios.get(`${domain.DBServer}/get-glof-basins/${river}`).then((result) => {
      if (result) {
        this.setState({
          basinnames: result.data,
          
        });
      }
    });
    let categories = [],
      series = [],
      categories_gl_type = [],
      series_gl_type = [];
    let totalcount = 0;
    let min_ele=min_el;
    let max_ele=max_el;
    let min_area=min_are;
    let max_area=max_are;
    
    axios
      .get(`${domain.DBServer}/get-glof-total-count-river-2023/${river}/${min_ele}/${max_ele}/${min_area}/${max_area}`)
      .then((result) => {
        if (result) {
          result.data.data1.map((result) => {
            let basin
            let string=result.basin.trim().split(" ")
            if(string.length>1)
            {
              basin=result.basin.trim().split(" ")
            }
            else 
            {
              basin=result.basin
            }
            
            categories.push(basin);
            return true;
          });
          result.data.data1.map((result) => {
            series.push(Number(result.count).toFixed());
            totalcount = totalcount + Number(result.count);
            return true;
          });
          console.log(series[0]);
          const isAllZero = series.every((item) => item === 0);
          console.log(isAllZero);
          result.data.data2.map((result) => {
            let gl_type=result.gl_type
            console.log("gl_type",gl_type)
           
            categories_gl_type.push(gl_type);
          });
      
          result.data.data2.map((result) => {
            console.log("result data2",result.count)
            series_gl_type.push(Number(result.count));
            //totalcount = totalcount + Number(result.count);
            return true;
          });

          this.setState({
            visibleGraphPanel_pie: true,
            visibleGraphPanel_pie1: true,

            categories: categories,
            xaxis: "Basins",
            title: river!=='Brahmaputra'?`Glacial Lakes in ${river} - (${Number(
              totalcount).toLocaleString("en-IN")})`:`Glacial Lakes in ${river} - (${Number(
                totalcount).toLocaleString("en-IN")}) `,
            yaxis: "No. of Glacial Lakes",
            series: series,
            units: "",
            categories_gl_type: categories_gl_type,
            series_gl_type: series_gl_type,
            title_gl_type: river!=='Brahmaputra'?`Glacial Lakes Type Distribution in ${river} `:`Glacial Lakes in ${river}  `,

            criticalglaciallakeselected:"cgl_all",
            selectedRegion: river,
            isAllZero:isAllZero,
            visible:window.innerWidth>1000?true:false,
            stateInfo:null,
            setcriticalboundary:false,
            critical_glacial_lake_boundary:null,
          });
        }
      });
 
     
  };
  handleGlacialLakeSelected = (e) => {
    let glacialLake=e.target.value;

    if (glacialLake != "Himalayas") {
      this.setState({
        glaciallakeselected: glacialLake,
        setcriticalboundary:false,
        criticalglaciallakeselected:"cgl_all",
        critical_glacial_lake_boundary:null,
        riverselected: "Himalayas",
        basinselected: "#",
        subbasinselected: "#",
      
    
  });
}
};
setCriticalGlacialLake=(value)=>
{
  this.setState({
    criticalglaciallakeselected:value
  })
}


handleCriticalGlacialLakeSelected = (e) => {
let criticalglacialLake=e.target.value
  if(criticalglacialLake!=="cgl_all")
  {
  this.setCriticalGlacialLake(criticalglacialLake)
    this.setState({
      //boundary:null
      glaciallakeselected:null,
      basinselected: "#",
      subbasinselected: "#",
      riverselected: "Himalayas",
     // series: null,
      //categories: null,
      stateInfo:null,      
      value:[100,400],
      value_area:[100,600],
      min_ele: 0,
      max_ele:8000,
      min_area:0.25,
      max_area:3000,
      min:100,
      min_ar:100,
      max:400,
      max_ar:600,
                  });
    let min_ele= 0;
    let max_ele=8000;
    let min_area=0.25;
    let max_area=3000;               
    console.log("criticalaaaall",criticalglacialLake)
    console.log("criticalaaaaa if  ")
    this. handleCGL(criticalglacialLake,min_ele,max_ele,min_area,max_area)

    this.setState({
     // series:null,
      //categories:null,
      //categories_gl_type:null,
      //series_gl_type:null,
      criticalglaciallakeselected: criticalglacialLake,
      critical_glacial_lake_boundaryall:null
   })
  }
   else{
    let min_ele= 0;
    let max_ele=8000;
    let min_area=0.25;
    let max_area=3000; 
    console.log("criticalaaaa else ")
    this.setCriticalGlacialLake(criticalglacialLake)
    this.setState({
      critical_glacial_lake_boundary:null
   })
  this.getBaseLayer_boundary()
   this.handleCGLall(min_ele,max_ele,min_area,max_area)
   }

};

 
setCriticalGlacialLakeBoundary=(info)=>
{
  if (info){
  this.setState({
    critical_glacial_lake_boundary:info,
    critical_gl_lake_boundary_status:true,
    //layer:null,
    //setcriticalboundary:true,
    riverselected:'Himalayas',
    //series: null,
    ///categories: null,
    //series_gl_type:null,
    //categories_gl_type:null,


    //stateInfo:null,
    boundary:null
  })
}
else {
this.setState({
  critical_gl_lake_boundary_status:false,
  critical_glacial_lake_boundary:false

})
}
  }
  setCriticalGlacialLakeBoundaryall=(info)=>
{
  if (info){
  this.setState({
    

   // layer:null,
    loading:true,
    critical_glacial_lake_boundaryall:info,
    boundary:this.state.himalayan_boundary,
   //critical_gl_lake_boundary_status:true,
    //layer:null,
    //setcriticalboundary:true,
    riverselected:'Himalayas',
    //series: null,
    //categories: null,
    //series_gl_type:null,
    //categories_gl_type:null,


    //stateInfo:null,
    
  })

}
else {
this.setState({
  critical_glacial_lake_boundaryall:null,
})
}
  }
  handleRiverSelected = (e) => {
    let river = e.target.value;

    if (river !== "Himalayas") {
      this.setState({
        riverselected: river,
        basinselected: "#",
        value:[100,400],
        value_area:[100,600],
        min_ele: 0,
        max_ele:8000,
        min_area:0.25,
        max_area:3000,
        
  
        min:100,
        min_ar:100,
        max:400,
        max_ar:600,
       // stateInfo:null,
        setcriticalboundary:false,
        criticalglaciallakeselected:"cgl_all",
        critical_glacial_lake_boundary:null,
        subbasinselected: "#",
        // basins:null,
        subbasin: null,
        subbasinnames: null,
        visibleGraphPanel_pie: false,
        visibleGraphPanel_pie1: false,

        series: null,
        categories: null,
        latlngposition: null,
      });

      let min_ele= 0;
      let max_ele=8000;
      let min_area=0.25;
      let max_area=3000;
      //this.getRiverStats(river,this.state.min_ele,this.state.max_ele,this.state.min_area,this.state.max_area);
        this.getRiverStats(river,min_ele,max_ele,min_area,max_area);

    } else {
      // alert('hai')

      this.setState({
        riverselected: "Himalayas",
        basinselected: "#",
        subbasinselected: "#",
        series: null,
        categories: null,
        basinnames: null,
        subbasinnames: null,
       // stateInfo:null,
        criticalglaciallakeselected:"cgl_all",
        value:[100,400],
        value_area:[100,600],
        min_ele: 0,
        max_ele:8000,
        min_area:0.25,
        max_area:3000,
  
        min:100,
        min_ar:100,
        max:400,
        max_ar:600,
        
      });
      this.getBaseLayer_boundary();
          this.getDefaultGLCount(this.state.min_ele,this.state.max_ele,this.state.min_area,this.state.max_area);
    }
  };
  setPopupState = (position) => {
    this.setState({
      latlngposition: position,
      key_p: numClick++,
    });
  };
  subbasinStats = (subbasin,min_el,max_el,min_are,max_are) => {
    let totalcount = 0;
    let min_ele=min_el;
    let max_ele=max_el;
    let min_area=min_are;
    let max_area=max_are;
    axios
      .get(
        `${domain.DBServer}/get-glof-subbasin-boundary/${this.state.riverselected}/${this.state.basinselected}/${subbasin}`
      )
      .then((result) => {
        if (result) {
          this.setState({
            boundary: result.data[0].basin_boundary,
          });
        }
      });

      let categories_gl_type=[],
      series_gl_type= [];
    /*let categories = [
      "<=0.5",
      "0.5-1.0",
      "1.0 - 5",
      "5 - 10",
      "10 - 50",
      ">50",
    ];*/
 
    let series = [];
    let categories = [
      "<=0.5",
      "0.5-1.0",
      "1.0 - 5",
      "5 - 10",
      "10 - 50",
      ">50",
    ];
    axios
      .get(
        `${domain.DBServer}/get-glof-subbasin-count-2023/${this.state.riverselected}/${this.state.basinselected}/${subbasin}/${min_ele}/${max_ele}/${min_area}/${max_area}`
      )
      .then((result) => {
        if (result) {
          series = result.data.data1.map((result) => {
            totalcount =
              totalcount +
              Number(result.one) +
              Number(result.two) +
              Number(result.three) +
              Number(result.four) +
              Number(result.five) +
              Number(result.six);
            return [
              Number(result.one),
              Number(result.two),
              Number(result.three),
              Number(result.four),
              Number(result.five),
              Number(result.six),
            ];
          });
          console.log(series);
          const isAllZero = series[0].every((item) => item === 0);

          result.data.data2.map((result) => {
            console.log("result data2",result.count)
            series_gl_type.push(Number(result.count));
            //totalcount = totalcount + Number(result.count);
            return true;
          });
          console.log("series for chart",series);
          result.data.data2.map((result) => {
            let gl_type=result.gl_type
            console.log("gl_type",gl_type)
           
            categories_gl_type.push(gl_type);
          });

          
        
        console.log("sssssssssssssubbasin stats",series,categories);

          console.log(isAllZero);
          this.setState({
            visibleGraphPanel_pie: true,
            visibleGraphPanel_pie1: true,

            categories: categories,
            criticalglaciallakeselected:"cgl_all",
            critical_glacial_lake_boundary:null,
            series: series[0],
            title: this.state.riverselected!=='Brahmaputra'?`Glacial Lakes in ${subbasin} (${this.state.basinselected} / ${
              this.state.riverselected}) - (${Number(totalcount).toLocaleString("en-IN")})`:`Glacial Lakes in ${subbasin} (${this.state.basinselected} / ${
                this.state.riverselected}) - (${Number(totalcount).toLocaleString("en-IN")}) `,
            xaxis: "Area (ha)",
             //units: "",
            yaxis: "No. of Glacial Lakes",
            categories_gl_type: categories_gl_type,
            series_gl_type: series_gl_type,
            isAllZero: isAllZero,
            selectedRegion: subbasin,
            title_gl_type:this.state.riverselected!=='Brahmaputra'?`Glacial Lakes Type Distribution in ${subbasin} (${this.state.basinselected} / ${
              this.state.riverselected})`:`Glacial Lakes Type Distribution in ${subbasin} (${this.state.basinselected} / ${
                this.state.riverselected})  `,

            visible:window.innerWidth>1000?true:false,
            stateInfo:null
          });
        }
      });


  };
  handleCriticalInudationBasinSim=(e)=>{

    this.setState({
      criticalIndSimBasinSelected:"#",
      series:null,
      criticalIndSimLakeSelected:"#",
      glofriskinundation:"#",
      criticalIndSimScenarioSelected:"#",
      criticalFeatureSelected:"#",
      selectedFactors:[],
      selectedFeatures:[],
      roadsChecked: false,
      agricultureChecked: false,
      hydropowerChecked: false,
      bridgesChecked: false,
      settlement_pointsChecked: false,
      settlement_polygonChecked: false,
    })
    
  let criticalInudationBasin=e.target.value;
  axios.get(`${domain.DBServer}/get-glof-risk-subbasins/${e.target.value}`).then((result) => {
    if (result) {
      this.setState({
        glofRiskSubbasins: result.data,
      });
    }
    console.log("result.data",result.data)
  });
  if( criticalInudationBasin!=='#'){
  this.setState({
    criticalIndSimBasinSelected:criticalInudationBasin,
    series:null,
  })
  axios
  .get(`${domain.DBServer}/get-himalayan-basin/${criticalInudationBasin}`)
  .then((result) => {
    if (result) {
      console.log(result);
      this.setState({
        criticalInudationBasinboundary: result.data[0].basin_boundary,
      });
    }
  });
}
else{
  this.getBaseLayer_boundary()
  
}

};

  handleCriticalInudataionLakeSim=(e)=>{
    let criticalIndSimLakeSelected=e.target.value;
    console.log("criticalIndSimLakeSelected",criticalIndSimLakeSelected)
    if(criticalIndSimLakeSelected!=="#"){
    this.setState({
      glofriskinundation:"#",
      InudationLakeSimBoundary:null,
        glofriskinundation:"#",
        criticalIndSimScenarioSelected:"#",
        criticalFeatureSelected:"#",
      //   roadsChecked: false,
      // agricultureChecked: false,
     
   
      
    })
    axios
    .get(`${domain.DBServer}/get-inundation-lake-boundary/${criticalIndSimLakeSelected.toLowerCase()}`)
    .then((result) => {
      if (result) {
        console.log(result);
          const boundary = result.data[0]?.boundary; // Ensure you handle potential undefined data

          // Only update the state once the API response is received
          this.setState({
            InudationLakeSimBoundary: boundary,
          criticalIndSimLakeSelected:criticalIndSimLakeSelected,

          hydropowerChecked: false,
          // bridgesChecked: false,
          // settlement_pointsChecked: false,
          // settlement_polygonChecked: false,
          roadsChecked:true,
          bridgesChecked:true,
          agricultureChecked:true,
          settlement_pointsChecked:true,
          settlement_polygonChecked:true,
          selectedFactors:[criticalIndSimLakeSelected+"_roads",criticalIndSimLakeSelected+"_bridges",criticalIndSimLakeSelected+"_settlement_polygon",criticalIndSimLakeSelected+"_settlement_points",criticalIndSimLakeSelected+"_agriculture"],
    
        })
      }
      else{
        this.setState({
          InudationLakeSimBoundary: null,
        });
      }
    });
  }
    else if (this.state.criticalIndSimBasinSelected==="#") {
      axios
      .get(`${domain.DBServer}/get-himalayan-basin/${this.state.criticalInudationBasin}`)
      .then((result) => {
        if (result) {
          console.log(result);
          this.setState({
            criticalInudationBasinboundary: result.data[0].basin_boundary,
          });
        }
      });

    }
   

  };
  handleCriticalRiskBasinSim=(e)=>{
    let criticalRiskBasin="#";
    this.setState({
      criticalRiskLakeSelected:"#",
      criticalRiskBasin:"#",
      glofRiskLakeBoundary:null,
      selectedFactors:[],
      selectedFeatures:[],

    })
    if(e.target.value!=="#"){
      criticalRiskBasin=e.target.value;
      axios.get(`${domain.DBServer}/get-glof-risk-subbasins/${criticalRiskBasin}`).then((result) => {
        if (result) {
          this.setState({
            glofRiskSubbasins: result.data,
          });
        }
      });


      this.setState({
        criticalRiskBasinSelected:criticalRiskBasin,
      })
      axios
      .get(`${domain.DBServer}/get-himalayan-basin/${criticalRiskBasin}`)
      .then((result) => {
        if (result) {
          console.log(result);
          this.setState({
            criticalRiskBasinboundary: result.data[0].basin_boundary,
          });
        }
      });

    }
    else{
      this.getBaseLayer_boundary()
      
    }

  }
  
  
    handleCriticalRiskLakeSim=(e)=>{

      this.setState({
        criticalRiskLakeSelected:"#",
        glofRiskLakeBoundary:null,
        //selectedFactors:[],

        selectedFeatures:[],
        hydropowerChecked:false,
      })


    
      let criticalRiskLakeSelected=e.target.value;



      console.log(criticalRiskLakeSelected,"criticalRiskLakeSelected")

      if(criticalRiskLakeSelected!=="#"&& criticalRiskLakeSelected !== this.state.criticalRiskLakeSelected){

        this.setState({
          selectedFactors:[criticalRiskLakeSelected+"_roads",criticalRiskLakeSelected+"_bridges",criticalRiskLakeSelected+"_settlement_polygon",criticalRiskLakeSelected+"_settlement_points",criticalRiskLakeSelected+"_agriculture"],

        roadsChecked: true,
        agricultureChecked: true,
        bridgesChecked: true,
        settlement_pointsChecked: true,
        settlement_polygonChecked: true,
        })
     
        axios
        .get(`${domain.DBServer}/get-risk-lake-boundary/${criticalRiskLakeSelected.toLowerCase()}`)
        .then((result) => {
          if (result) {
            console.log(result);
            this.setState({
              glofRiskLakeBoundary: result.data[0].boundary,
            });
          }
          else{
            this.setState({
              glofRiskLakeBoundary: null,
            });
          }
        });
        this.setState({
          criticalRiskLakeSelected:criticalRiskLakeSelected,
         

        })
      }
      
        else if (this.state.criticalRiskLakeSelected==="#") {
          axios
          .get(`${domain.DBServer}/get-himalayan-basin/${this.state.criticalRiskBasin}`)
          .then((result) => {
            if (result) {
              console.log(result);
              this.setState({
                boundary: result.data[0].basin_boundary,
              });
            }
          });
    
        }
  
    };
  handleCriticalIndSimScenario=(e)=>{
    let criticalIndSimScenarioSelected=e.target.value;

    console.log(criticalIndSimScenarioSelected,"criticalIndSimScenarioSelected")
    this.setState({
      criticalIndSimScenarioSelected:criticalIndSimScenarioSelected,
      depthChecked:true,
      selectedFeatures:[this.state.criticalIndSimLakeSelected+"_"+this.state.glofriskinundation+"_"+criticalIndSimScenarioSelected+"_depth"],
      ///criticalRiskBasinSelected:'#',
      //criticalRiskLakeSelected:'#',


      selectedFactors:[this.state.criticalIndSimLakeSelected+"_roads",this.state.criticalIndSimLakeSelected+"_bridges",this.state.criticalIndSimLakeSelected+"_settlement_polygon",this.state.criticalIndSimLakeSelected+"_settlement_points",this.state.criticalIndSimLakeSelected+"_agriculture"],
      roadsChecked:true,
      bridgesChecked:true,
      settlement_pointsChecked:true,
      settlement_polygonChecked:true,
      agricultureChecked:true,
      
    })};
    handleCriticalIndSimScenarioRisk=(e)=>{
      let criticalIndSimScenarioSelectedRisk=e.target.value;
      let legend_SimScenario="risk"+(e.target.value).split("_")[1]
  
      console.log(criticalIndSimScenarioSelectedRisk,"criticalIndSimScenarioSelected",legend_SimScenario)
      this.setState({
        criticalIndSimScenarioSelectedRisk:criticalIndSimScenarioSelectedRisk,
        legend_SimScenario:legend_SimScenario,
  
        ///criticalRiskBasinSelected:'#',
        //criticalRiskLakeSelected:'#',
        
        
      })};

  handleCriticalFeature=(e)=>{
    let criticalFeatureSelected=e.target.value;
    this.setState({
      criticalfeatureSelected:criticalFeatureSelected,
      //selectedFactors:[],
      //criticalRiskBasinSelected:'#',
      //criticalRiskLakeSelected:'#',

    })
  
    const { name, value, checked } = e.target;
    const { selectedFeatures } = this.state;

    
    this.setState({
      [`${value}Checked`]: checked, // Dynamically updating the checkbox state
    });
  

    if (checked) {
      this.setState({
        selectedFeatures: [...selectedFeatures, this.state.criticalIndSimLakeSelected+"_"+this.state.glofriskinundation+"_"+this.state.criticalIndSimScenarioSelected+"_"+value]
      });
    } else {
      // If checkbox is unchecked, remove the value from the selectedFactors array
      this.setState({
        selectedFeatures: selectedFeatures.filter(factor => factor !==this.state.criticalIndSimLakeSelected+"_"+this.state.glofriskinundation+"_"+this.state.criticalIndSimScenarioSelected+"_"+value)
      });
    }
    console.log("selddd",this.state.selectedFeatures)
   
  
  };
   handleIndCriticalFactor=(e)=>{
    console.log("valuesss e",e.target)
    const { name, value, checked } = e.target;
    this.setState({
      [`${value}Checked`]: checked, // Dynamically updating the checkbox state
    });
    let value1='',value2='';
    const { selectedFactors } = this.state;
  console.log("valuesss",value)
    if (checked) {
      
      // If checkbox is checked, add the value to the selectedFactors array
      this.setState({
        selectedFactors: [...selectedFactors, this.state.criticalIndSimLakeSelected+"_"+value],
        //criticalIndSimBasinSelected:'#',
       //criticalIndSimLakeSelected:'#',
       // selectedFeatures:[],
      });

      if(value==="settlement_points")
      {
        console.log("valuesss in if",value)
        value1="settlement_polygon"
         value2="Settlement_Names"


        this.setState((prevState) => ({
          selectedFactors: [...prevState.selectedFactors,this.state.criticalIndSimLakeSelected+"_"+value1,this.state.criticalIndSimLakeSelected+"_"+value2],


          //criticalIndSimBasinSelected:'#',
         //criticalIndSimLakeSelected:'#',
          //selectedFeatures:[],
        }));
      }
    } else {
      // If checkbox is unchecked, remove the value from the selectedFactors array
      console.log("valuesss in else", value);
      if (value === "settlement_points") {
        value1 = "settlement_polygon";
        value2 = "Settlement_Names";
    
        this.setState((prevState) => ({
          selectedFactors: prevState.selectedFactors.filter(
            (factor) => factor !== this.state.criticalIndSimLakeSelected+"_"+value1 && factor !== this.state.criticalIndSimLakeSelected+"_"+value2 && factor !==this.state.criticalIndSimLakeSelected+"_"+value
          ),
         // selectedFeatures: [],
        }));
      } else {
        this.setState((prevState) => ({
          selectedFactors: prevState.selectedFactors.filter(
            (factor) => factor !== this.state.criticalIndSimLakeSelected+"_"+value
          ),
         // selectedFeatures: [],
        }));
      }
    }
    console.log("selecteddd",this.state.selectedFactors,this.state.criticalIndSimLakeSelected)
  };
  handleCriticalFactor=(e)=>{
    console.log("valuesss e",e.target)
    const { name, value, checked } = e.target;
    this.setState({
      [`${value}Checked`]: checked, // Dynamically updating the checkbox state
    });
    let value1='',value2='';
    const { selectedFactors } = this.state;
  console.log("valuesss",value)
    if (checked) {
      
      // If checkbox is checked, add the value to the selectedFactors array
      this.setState({
        selectedFactors: [...selectedFactors, this.state.criticalRiskLakeSelected+"_"+value],
        //criticalIndSimBasinSelected:'#',
       //criticalIndSimLakeSelected:'#',
       // selectedFeatures:[],
      });

      if(value==="settlement_points")
      {
        console.log("valuesss in if",value)
        value1="settlement_polygon"
         value2="Settlement_Names"


        this.setState((prevState) => ({
          selectedFactors: [...prevState.selectedFactors,this.state.criticalRiskLakeSelected+"_"+value1,this.state.criticalRiskLakeSelected+"_"+value2],


          //criticalIndSimBasinSelected:'#',
         //criticalIndSimLakeSelected:'#',
          //selectedFeatures:[],
        }));
      }
    } else {
      // If checkbox is unchecked, remove the value from the selectedFactors array
      console.log("valuesss in else", value);
      if (value === "settlement_points") {
        value1 = "settlement_polygon";
        value2 = "Settlement_Names";
    
        this.setState((prevState) => ({
          selectedFactors: prevState.selectedFactors.filter(
            (factor) => factor !== this.state.criticalRiskLakeSelected+"_"+value1 && factor !== this.state.criticalRiskLakeSelected+"_"+value2 && factor !==this.state.criticalRiskLakeSelected+"_"+value
          ),
         // selectedFeatures: [],
        }));
      } else {
        this.setState((prevState) => ({
          selectedFactors: prevState.selectedFactors.filter(
            (factor) => factor !== this.state.criticalRiskLakeSelected+"_"+value
          ),
         // selectedFeatures: [],
        }));
      }
    }
    console.log("selecteddd",this.state.selectedFactors,this.state.criticalIndSimLakeSelected)
  };
  handleSubbasinChange = (e) => {    
    let subbasin = e.target.value;
    console.log("aaasubbasin:",subbasin)

    if (subbasin !== "#") {
      this.setState({
        value:[100,400],
        value_area:[100,600],
        min_ele: 0,
        max_ele:8000,
        min_area:0.25,
        max_area:3000,
        stateInfo:null,
        setcriticalboundary:false,
        criticalglaciallakeselected:"cgl_all",
        critical_glacial_lake_boundary:null,
        min:100,
        min_ar:100,
        max:400,
        max_ar:600,
        subbasinselected: subbasin,
        visibleGraphPanel_pie: false,
        visibleGraphPanel_pie1: false,

        series: null,
        categories: null,
      });
      let min_ele= 0;
      let max_ele=8000;
      let min_area=0.25;
      let max_area=3000;
      console.log("aaathis.subbasinStats(",subbasin,this.state.min_ele,this.state.max_ele,this.state.min_area,this.state.max_area);
      //this.subbasinStats(subbasin,this.state.min_ele,this.state.max_ele,this.state.min_area,this.state.max_area);

      this.subbasinStats(subbasin,min_ele,max_ele,min_area,max_area);
    } else {
      this.setState({
        riverselected: this.state.riverselected,
        basinselected: this.state.basinselected,
        criticalglaciallakeselected:"cgl_all",
        critical_glacial_lake_boundary:null,
        subbasinselected: "#",
        series: null,
        categories: null,
        stateInfo:null,
        
          value:[100,400],
          value_area:[100,600],
          min_ele: 0,
          max_ele:8000,
          min_area:0.25,
          max_area:3000,
    
          min:100,
          min_ar:100,
          max:400,
          max_ar:600,
      });
      let min_ele= 0;
      let max_ele=8000;
      let min_area=0.25;
      let max_area=3000;

      this.basinStats(this.state.basinselected,min_ele,max_ele,min_area,max_area);

      //this.basinStats(this.state.basinselected,this.state.min_ele,this.state.max_ele,this.state.min_area,this.state.max_area);
    }
  };

  basinStats = (basin,min_el,max_el,min_are,max_are) => {

    let min_ele=min_el;
    let max_ele=max_el;
    let min_area=min_are;
    let max_area=max_are;

    
    /*if (min_area==0.25 && max_area==0.25)
    {
      min_area=0
    }
    if (min_area== 3000 && max_area==3000)
    {
      min_area=100,
      max_area=3000
    }
    if (min_ele==)
    */

    axios
      .get(
        `${domain.DBServer}/get-glof-basin-boundary/${this.state.riverselected}/${basin}`
      )
      .then((result) => {
        if (result) {
          this.setState({
            boundary: result.data[0].basin_boundary,
          });
        }
      });
    axios
      .get(
        `${domain.DBServer}/get-glof-subbasins/${this.state.riverselected}/${basin}`
      )
      .then((result) => {
        if (result) {
          this.setState({
            subbasinnames: result.data,
          });
        }
      });
    let categories = [],
      series = [],
      categories_gl_type=[],
      series_gl_type= [];
    let totalcount = 0;
    axios
      .get(
        `${domain.DBServer}/get-glof-total-count-river-basin-2023/${this.state.riverselected}/${basin}/${min_ele}/${max_ele}/${min_area}/${max_area}`
      )
      .then((result) => {
        if (result) {
          result.data.data1.map((result) => {
            let basin
            let string=result.basin.trim().split(" ")
            if(string.length>1)
            {
              basin=result.basin.trim().split(" ")
            }
            else 
            {
              basin=result.basin
            }
            
            categories.push(basin);
            return true;
          });
          result.data.data1.map((result) => {
            series.push(Number(result.count).toFixed(0));
            totalcount = totalcount + Number(result.count);
            return true;
          });
          console.log(series);
          result.data.data2.map((result) => {
            let gl_type=result.gl_type
            console.log("gl_type",gl_type)
           
            categories_gl_type.push(gl_type);
          });
          console.log("gggggggggggggggggggggltype",categories_gl_type)
      
          result.data.data2.map((result) => {
            console.log("result data2",result.count)
            series_gl_type.push(Number(result.count));
            //totalcount = totalcount + Number(result.count);
            return true;
          });
         
         
          this.setState({
            visibleGraphPanel_pie: true,
            visibleGraphPanel_pie1: true,

            categories: categories,
            series: series,
            xaxis: "Sub Basins",
            title:this.state.riverselected!=='Brahmaputra'?`Sub Basin Wise Glacial Lakes in ${basin} (${
              this.state.riverselected}) - (${Number(totalcount).toLocaleString("en-IN")})`:`Sub Basin Wise Glacial Lakes in ${basin} (${
                this.state.riverselected}) - (${Number(totalcount).toLocaleString("en-IN")}) `,
           //units: "",
            yaxis: "No. of Glacial Lakes",
            categories_gl_type: categories_gl_type,
            series_gl_type: series_gl_type,
            selectedRegion: basin,
            title_gl_type:this.state.riverselected!=='Brahmaputra'?`Sub Basin Wise Glacial Lakes Type Distribution in ${basin} (${
              this.state.riverselected}) `: `Sub Basin Wise Glacial Lakes Type Distribution in ${basin} (${
                this.state.riverselected})`,
        
            isAllZero:series.length===0?true:false,
            visible:window.innerWidth>1000?true:false,
            stateInfo:null,
            criticalglaciallakeselected:"cgl_all",
            critical_glacial_lake_boundary:null,
          });
        }
      });

  
  
       
  };

  handleBasinChange = (e) => {
    let basin = e.target.value;
    if (basin !== "#") {
      this.setState({
        basinselected: basin,
        value:[100,400],
        value_area:[100,600],
        min_ele: 0,
        max_ele:8000,
        min_area:0.25,
        max_area:3000,
        
  
        min:100,
        min_ar:100,
        max:400,
        max_ar:600,
        visibleGraphPanel_pie: false,
        visibleGraphPanel_pie1: false,

        series: null,
        categories: null,
        stateInfo:null,
        criticalglaciallakeselected:"cgl_all",
        critical_glacial_lake_boundary:null,
        setcriticalboundary:false,
      });

      let min_ele= 0;
      let max_ele=8000;
      let min_area=0.25;
      let max_area=3000;
      //.basinStats(basin,this.state.min_ele,this.state.max_ele,this.state.min_area,this.state.max_area );

      this.basinStats(basin,min_ele,max_ele,min_area,max_area );
    } else {
      // alert('hai')
      // this.handleRiverSelected()
      this.setState({
        riverselected: this.state.riverselected,
        basinselected: " #",
        subbasinselected: "#",
        series: null,
        categories: null,
        subbasinnames: null,
        criticalglaciallakeselected:"cgl_all",
        critical_glacial_lake_boundary:null,
        stateInfo:null
      });
      let min_ele= 0;
      let max_ele=8000;
      let min_area=0.25;
      let max_area=3000;
      
      this.getRiverStats(this.state.riverselected,min_ele,max_ele,min_area,max_area);
    }
  };
  setStateInfoStatus = () => {
    this.setState({
      stateInfo: null,
      stateInfoStatus: !this.state.stateInfoStatus,
    });
  };
  handleDialogClose = () => {
    this.setState({
      visibleGraphPanel_pie: !this.state.visibleGraphPanel_pie,
    });
  };
  handleDialogClose1 = () => {
    this.setState({
      visibleGraphPanel_pie1: !this.state.visibleGraphPanel_pie1,
    });
  };
  handleDialogTClose = () => {
    this.setState({
      technicalnoteenable: false,
    });
  };
  handleDialogDClose = () => {
    this.setState({
      disclaimerenable: false,
    });
  };
  handleTechnicalNote = () => {
    this.setState({
      technicalnoteenable: true,
      disclaimerenable: false,
      visibleGraphPanel: false,
      visibleGraphPanel1: false,

      visible:window.innerWidth>1000?true:false,
    });
  };
  handleDisclaimer = () => {
    this.setState({
      technicalnoteenable: false,
      disclaimerenable: true,
      visible:window.innerWidth>1000?true:false,
    });
  };

  handleTechnicalNote = () => {
    this.setState({
      technicalnoteenable: true,
      disclaimerenable: false,
      visibleGraphPanel_pie: false,
      visibleGraphPanel_pie1: false,


      visible:window.innerWidth>1000?true:false,
    });
  };
  handleDisclaimer = () => {
    this.setState({
      technicalnoteenable: false,
      disclaimerenable: true,
      visibleGraphPanel_pie: false,
      visibleGraphPanel_pie1: false,

      visible:window.innerWidth>1000?true:false,
    });
  };


  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  render() {
    
    let river_system, basin_system, subbasin_system,river_system_cgl,status_visible,risk_basins,risk_subbasins;
    //console.log(this.state.collapsed,this.state.collapsed2,"collap")
    //console.log("glofriskassesmentselected",this.state.glofriskassesmentselected);

console.log("this.state.width",this.state.width,this.state.width1)
    //console.log("bounnnnnnnnnnnnnn",this.state.himalayan_boundary,this.state.boundary,this.state.india_states_boundary)
    if (this.state.rivernames) {
      river_system = this.state.rivernames.map((river) => {
        return <option value={river.basin}>{river.basin}</option>;
      });
    }
    if (this.state.basinnames) {
      basin_system = this.state.basinnames.map((river) => {
        return <option value={river.basin}>{river.basin}</option>;
      });
    }
    if (this.state.glofRiskBasins) {

      risk_basins = this.state.glofRiskBasins.map((basin) => {
        return <option value={basin.basin}>{basin.basin}</option>;
      });
    }
    if (this.state.glofRiskSubbasins) {

      risk_subbasins = this.state.glofRiskSubbasins.map((subbasin) => {
        return <option value={subbasin.subbasin}>{subbasin.subbasin_display}</option>;
      });
    }

    if (this.state.subbasinnames) {
      subbasin_system = this.state.subbasinnames.map((river) => {
        return <option value={river.basin}>{river.basin}</option>;
      });
    }

    if (this.state.cgl_rivernames) {
      river_system_cgl = this.state.cgl_rivernames.map((river) => {
        return <option value={river.river_syst}>{river.river_syst}</option>;
      });
    }
    if (this.state.cgl_rivernames) {
      status_visible = this.state.cgl_rivernames.map((river) => {
        return <option value={river.status}>{river.status}</option>;
      });
    }
    // if (
    //   this.state.riverselected !== "#" &&
    //   this.state.basinselected !== "#" &&
    //   this.state.subbasinselected !== "#"
    // ) {
    //   selectedRegion = this.state.subbasinselected;
    // } else if (
    //   this.state.riverselected !== "#" &&
    //   this.state.basinselected !== "#" &&
    //   this.state.subbasinselected === "#"
    // ) {
    //   selectedRegion = this.state.basinselected;
    // } else if (
    //   this.state.riverselected !== "#" &&
    //   this.state.basinselected === "#" &&
    //   this.state.subbasinselected !== "#"
    // ) {
    //   selectedRegion = this.state.riverselected;
    // } else {
    //   selectedRegion = "Himalayan Region";
    // }
    // let params = new URLSearchParams(this.props.location.search);

    console.log(this.state.chartData);

    return (
      <div
        style={{ backgroundColor: colors.textcolor, height: "100%" }}
        ref={(ref) => {
          this._menuBlock = ref;
        }}
      >
        <AboutModal
            modal={this.props.glmodal}
            toggle={this.props.toggle}
            title={pagecontent.title}
            bodycontent={pagecontent.bodycontent}
            link={pagecontent.link}
          />
        <Sidebar.Pushable
          as={Segment}
         // style={{ backgroundColor: colors.background }}
          style={{
            marginTop: "0px",
            backgroundColor: "blue",
            border: "0px",
            transfrom: "0px",
          }}
        >
          <Sidebar
            as={Menu}
            animation="slide out"
            direction="left"
            icon="labeled"
            inverted
            vertical
            visible={this.state.visible}
            // width='wide'
            style={{
              backgroundColor: colors.sidebarBackground,
              textAlign: "left",
              width: "260px",
              padding: "0px",
              border: "0px",
            }}
          >
            <div className="modalwindow">
              <div
                as="div"
                onClick={this.GlacialCheck}
                className="modalheader"
                style={{ textAlign: "left" }}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ width: "80%" }}> Glacial Lakes</div>
                  <div style={{ textAlign: "right", width: "20%" }}>
                    {this.state.collapsed ? (
                      <FontAwesomeIcon icon="angle-down" />
                    ) : (
                        <FontAwesomeIcon icon="angle-right" />
                      )}
                  </div>
                </div>
              </div>

              {this.state.collapsed ? (
                <div
                  style={{
                    background: colors.final_side_inner,
                    padding: "0px",
                    textAlign: "-webkit-center",
                  }}
                >
                  <select
                    onChange={this.handleRiverSelected}
                    value={this.state.riverselected}
                    selected={this.state.riverselected}
                  >
                    <option value="Himalayas" selected>
                      Select River System
                    </option>
                    {river_system}
                  </select>
                  <select
                    onChange={this.handleBasinChange}
                    value={this.state.basinselected}
                  >
                    <option value="#">Select Basin </option>
                    {basin_system}
                  </select>
                  <select
                    onChange={this.handleSubbasinChange}
                    value={this.state.subbasinselected}
                  >
                    <option value="#">Select Subbasin</option>
                    {subbasin_system}
                  </select>
                </div>
              ) : null}
            </div>

                   

            <div className="modalwindow">
              <div
                as="div"
                onClick={this.GLRAssessment}
                className="modalheader"
                style={{ textAlign: "left" }}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ width: "80%", opacity: "1.0" }}>
                    GLOF Risk Assessment
                  </div>
                  <div style={{ textAlign: "right", width: "20%" }}>
                    {this.state.collapsed2 ? (
                      <FontAwesomeIcon icon="angle-down" />
                    ) : (
                      <FontAwesomeIcon icon="angle-right" />
                    )}
                  </div>
                </div>
              </div>
              {this.state.collapsed2 ? (
                <div>
                  <div
                    style={{
                      background: colors.final_side_sub,
                      //padding: "5px",
                    }}
                  >
                    <Menu.Item
                      as="div"
                      style={{ textAlign: "left", color: colors.text_sub_color }}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "10%" }}>
                        <input
                          type="radio"
                          name="glacialRisk"
                          value="cgl"
                          checked={this.state.glofriskassesmentselected === "cgl"}
                          onChange={this.handleGlofRiskAssessmentChange}
                        />
                        </div>
  
                        <div style={{ width: "90%", opacity: "1.0" }}>
                          Selected Glacial Lakes
                        </div>
                      </div>
                      {this.state.glofriskassesmentselected === "cgl" && (
                        <div   style={{
                          background: colors.final_side_sub,
                          color: colors.text_sub_color,
                          padding: "5px 0px 0px 17px ",
                        }}>
                      <select
                  onChange={this.handleCriticalGlacialLakeSelected}
                    value={this.state.criticalglaciallakeselected}
                    selected={this.state.criticalglaciallakeselected}
                  >
                    <option value="cgl_all" selected>
                      Select Basin
                    </option>
                    
                    {river_system_cgl}
                    
        
                  </select>
                  </div>
                      )}
                    </Menu.Item>
                    
                  </div>
                  
                  <div
  style={{
    background: colors.final_side_sub,
    color: colors.text_sub_color,
    padding: "0px",
  }}
>
  <Menu.Item
    as="div"
    style={{ textAlign: "left", color: colors.text_sub_color}}
  >
    <div style={{ display: "flex" }}>
      <div style={{ width: "10%" }}>
        <input
          type="radio"
          name="glacialRisk"
          value="gis"
          checked={this.state.glofriskassesmentselected === "gis"}
          onChange={this.handleGlofRiskAssessmentChange}
         // disabled={true}
        />
      </div>

      <div style={{ width: "90%", opacity: "1.0" }}>
        GLOF Inundation Simulation

        {/* Conditionally render additional content */}
        {this.state.glofriskassesmentselected === "gis" && (
          <div>
            {/* Select Basin */}
            <div
              style={{
                background: colors.final_side_sub,
                color: colors.text_sub_color,
                padding: "5px",
              }}
            >
              <select
                onChange={this.handleCriticalInudationBasinSim}
                value={this.state.criticalIndSimBasinSelected}
              >
                 <option value="#" selected>
                  Select Basin
                </option>
                {risk_basins}
                {/*<option value="Indus" >Indus</option>
                {/*{river_system_cgl}*/}
              </select>
            </div>
            {/* Select Critical Lakes */}
            {this.state.criticalIndSimBasinSelected !=="#" && (
              <div>
            <div
              style={{
                background: colors.final_side_sub,
                color: colors.text_sub_color,
                padding: "5px",
              }}
            >
              <select
                   onChange={this.handleCriticalInudataionLakeSim}
                   value={this.state.criticalIndSimLakeSelected}
              >
                <option value="#" selected>
                  Select Lake
                </option>
                {risk_subbasins}
               
              </select>
            </div>
            {this.state.criticalIndSimLakeSelected !=="#" && (
              <div>
                <b style={{padding:"5px"}}>Failure Modes</b>
              
            <div style={{ display: "flex" }}>
                        <div style={{ width: "10%" ,  background: colors.final_side_sub,
                color: colors.text_sub_color,
                padding: "5px"}}>
                          <input  type="radio"
       				name="risk"
        			value="ot"
        			checked	={this.state.glofriskinundation === "ot"}
        			onChange={this.handleGlofRiskInundation} 
              //disabled={true}
              />
                        </div>

                        <div
              style={{
                background: colors.final_side_sub,
                color: colors.text_sub_color,
                padding: "4px",
              }}
            >
                       Overtopping Failure
                        

                       {this.state.glofriskinundation === "ot" && (



                        <div style={{
                          background: colors.final_side_sub,
                          color: colors.text_sub_color,
                          padding: "5px",
                        }}>
                          
                       <select
                  onChange={this.handleCriticalIndSimScenario}
                    value={this.state.criticalIndSimScenarioSelected}
                    selected={this.state.criticalIndSimScenarioSelected}
                  >
              
                    <option value="#" selected>
                      Scenario
                    </option>
                    <option value="100">
                    100% Volume Release (Clear Weather)  </option>
                    <option value="75">
                    75% Volume Release (Clear Weather) </option>
                    <option value="50">
                    50% Volume Release (Clear Weather) </option>
                    <option value="100_pmp">
                    100% Volume Release (PMP) </option>
                    </select>
                    {  this.state.criticalIndSimScenarioSelected!=="#" && ( 
                      <div>
                         <div   style={{
                          background: colors.final_side_sub,
                          color: colors.text_sub_color,
                          padding: "10px 0px 5px 0px",
                        }}> 
                          
                        <input type="checkbox" name="feat" value="velocity"	 checked={this.state.velocityChecked}  onChange={this.handleCriticalFeature} />
                        {" Flood Velocity"}
                        </div>
                        <div style={{
                      
                          padding: "10px 0px 5px 0px",
                        }}> 
                        <input type="checkbox" name="feat" value="depth"  checked={this.state.depthChecked} onChange={this.handleCriticalFeature} />
                        {" Flood Depth"}
                        </div>
                        <div style={{
                      
                      padding: "10px 0px 5px 0px",
                    }}> 
                    <input type="checkbox" name="feat" value="inundation" checked={this.state.inundationChecked} onChange={this.handleCriticalFeature} />
                    {" Flood Inundation Extent"}
                    </div>
                    </div>
                    )}

                        </div>
                        )}

                        </div>
                        </div>
                       
                        <div style={{ width: "90%", opacity: "1.0" ,padding: "5px"}}>
                        <div >

                          <input  type="radio"
        			name="risk"
        			value="pip"
        			checked={this.state.glofriskinundation === "pip"}
        			onChange={this.handleGlofRiskInundation}
              //disabled={true}
                />
                      

                      
                        {"  Piping Failure"}
                        </div>
                        </div>
                        {this.state.glofriskinundation === "pip" && (
                        <div style={{ width: "90%", opacity: "1.0" ,padding: "0px 0px 0px 35px"}}>
                        <select
                   onChange={this.handleCriticalIndSimScenario}
                   value={this.state.criticalIndSimScenarioSelected}
                   selected={this.state.criticalIndSimScenarioSelected}
                 >
                 
                    <option value="#" selected>
                      Scenario
                    </option>
                    <option value="100">
                    100% Volume Release (Clear Weather)   </option>
                    <option value="75">
                    75% Volume Release (Clear Weather) </option>
                    <option value="50">
                    50% Volume Release (Clear Weather) </option>
                    <option value="100_pmp">
                    100% Volume Release (PMP) </option>
                    </select>

                    {  this.state.criticalIndSimScenarioSelected!=="#" && ( 
                      <div>
                         <div   style={{
                          background: colors.final_side_sub,
                          color: colors.text_sub_color,
                          padding: "10px 5px 5px 0px",
                        }}> 
                          
                          <input type="checkbox" name="feat" value="velocity"	 checked={this.state.velocityChecked}  onChange={this.handleCriticalFeature} />
                        {" Flood Velocity"}
                        </div>
                        <div style={{
                      
                          padding: "10px 0px 5px 0px",
                        }}> 
                        <input type="checkbox" name="feat" value="depth"  checked={this.state.depthChecked} onChange={this.handleCriticalFeature} />
                        {" Flood Depth"}
                        </div>
                        <div style={{
                      
                      padding: "10px 0px 5px 0px",
                    }}> 
                    <input type="checkbox" name="feat" value="inundation" checked={this.state.inundationChecked} onChange={this.handleCriticalFeature} />
                    {" Flood Inundation Extent"}
                    </div>
                    </div>
                    )}


              
                        

                        </div>
                        )}
                       <b style={{padding: "4px"}}> Exposed Element Layers </b>

<div   style={{
                          background: colors.final_side_sub,
                          color: colors.text_sub_color,
                          padding: "10px 0px 5px 5px",
                          
                        }}> 
                          
                        <input type="checkbox" name="factor" value="roads" checked={this.state.roadsChecked}
        			onChange={this.handleIndCriticalFactor}/>
                        {" Roads"}
                        </div>
                        <div style={{
                      
                          padding: "5px 0px 5px 5px",
                        }}> 
                             <input type="checkbox" name="factor" value="bridges" checked={this.state.bridgesChecked}
        			onChange={this.handleIndCriticalFactor} />
                        {" Bridges"}
                        </div>
                        <div style={{
                      
                          padding: "5px 0px 5px 5px",
                        }}> 
                             <input type="checkbox" name="factor" value="settlement_points" checked={this.state.settlement_pointsChecked}
        			onChange={this.handleIndCriticalFactor} />
                        {" Settlements"}
                        </div>
                        <div style={{
                      
                      padding: "5px 0px 5px 5px",
                    }}> 
                    <input type="checkbox" name="factor" value="agriculture"  checked={this.state.agricultureChecked}
          onChange={this.handleIndCriticalFactor} />
                    {" Agricultural Land"}
                    </div>
                     {  (this.state.criticalIndSimLakeSelected!=="GhepangGhat" &&this.state.criticalIndSimLakeSelected!=="SamudraTapu" && this.state.criticalIndSimLakeSelected!=="Katkar")&&(
                          <div style={{
                      padding: "5px 0px 5px 5px",
                    }}> 
                    <input type="checkbox" name="factor" value="hydropower" checked={this.state.hydropowerChecked}
          onChange={this.handleIndCriticalFactor} />
                    {"Hydropower Projects"}
                    </div>


                        )}

                        </div>
            )}
                        </div>
                        )}
                        
          </div>
        )}
      </div>
    </div>
  </Menu.Item>
</div>
                     
                  <div
                    style={{
                      background: colors.final_side_sub,
                      color: colors.text_sub_color,
                      padding: "0px",
                    }}
                  >
                    <Menu.Item
                      as="div"
                      style={{ textAlign: "left", color: colors.text_sub_color }}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "10%" }}>
                          <input type="radio"        
                          name="glacialRisk"
                          value="gr"
                          checked={this.state.glofriskassesmentselected === "gr"}
                          onChange={this.handleGlofRiskAssessmentChange} 
                         // disabled={true}
                         />
                        </div>

                        <div style={{ width: "90%", opacity: "", padding: "0px"}}>
                          GLOF Risk Zones
                          {this.state.glofriskassesmentselected === "gr" && (
                            <div>
                               <div
              style={{
                background: colors.final_side_sub,
                color: colors.text_sub_color,
                padding: "5px",
              }}
            >
             <select
                onChange={this.handleCriticalRiskBasinSim}
                value={this.state.criticalRiskBasinSelected}
              >
                 <option value="#" selected>
                  Select Basin
                </option>
                {risk_basins}
                {/* <option value="Indus" >Indus</option>
               {river_system_cgl}*/}
              </select>
            </div>

            {/* Select Critical Lakes */}
            {this.state.criticalRiskBasinSelected!=="#" &&(
              <div>
            
            <div
              style={{
                background: colors.final_side_sub,
                color: colors.text_sub_color,
                padding: "5px",
              }}
            >
            <select
                   onChange={this.handleCriticalRiskLakeSim}
                   value={this.state.criticalRiskLakeSelected}
              >
                <option value="#" selected>
                  Select Lake
                </option>
                {risk_subbasins}
                 {/*<option value="Ghepan Ghat" >Ghepang Ghat</option>
                {river_system_cgl}*/}
              </select>
            </div>

              {this.state.criticalRiskLakeSelected!=="#" &&(
                <div>
            <div style={{ width: "90%", opacity: "1.0" ,padding: "0px 0px 0px 5px"}}>
            <select
                  onChange={this.handleCriticalIndSimScenarioRisk}
                    value={this.state.criticalIndSimScenarioSelectedRisk}
                    selected={this.state.criticalIndSimScenarioSelectedRisk}
                  >
                 
                    <option value="#" selected>
                      Scenario
                    </option>
                    <option value="ot_100">
                    100% discharge Overtopping</option>

                    <option value="pip_100">
                    100% discharge piping</option>

                    <option value="ot_75">

                    75% discharge Overtopping</option>
                    <option value="pip_75">
                    75% discharge piping</option>

                    <option value="ot_50">
                    50% discharge Overtopping</option>
                    <option value="pip_50">
                    50% discharge piping</option>
                   
                    </select>
                    </div>

                              <div   style={{
                          background: colors.final_side_sub,
                          color: colors.text_sub_color,
                          padding: "5px 0px 10px 15px",
                         
                          
                        }}> 
                          
                        <input type="checkbox" name="factor" value="roads" checked={this.state.roadsChecked}
        			onChange={this.handleCriticalFactor}/>
                        {" Roads"}
                        </div>
                        <div style={{
                      
                          padding: "5px 0px 10px 15px",
                        }}> 
                             <input type="checkbox" name="factor" value="bridges" checked={this.state.bridgesChecked}
        			onChange={this.handleCriticalFactor} />
                        {" Bridges"}
                        </div>
                        <div style={{
                      
                          padding: "5px 0px 10px 15px",
                        }}> 
                             <input type="checkbox" name="factor" value="settlement_points" checked={this.state.settlement_pointsChecked}
        			onChange={this.handleCriticalFactor} />
                        {" Settlements"}
                        </div>
                        <div style={{
                      
                          padding: "5px 0px 10px 15px",
                        }}> 
                        <input type="checkbox" name="factor" value="agriculture" checked={this.state.agricultureChecked}
        			onChange={this.handleCriticalFactor} />
                        {" Agricultural Land"}
                        </div>

                        { ( this.state.criticalRiskLakeSelected!=="GhepangGhat" &&this.state.criticalRiskLakeSelected!=="SamudraTapu" && this.state.criticalRiskLakeSelected!=="Katkar") &&(
                          <div style={{
                      
                      padding: "5px 0px 10px 15px",
                    }}> 

                    
                    <input type="checkbox" name="factor" value="hydropower" checked={this.state.hydropowerChecked}
          onChange={this.handleCriticalFactor} />
                    {"Hydropower Projects"}
                    </div>


                        )}
                        

                        </div>
              )}
                        </div>
            )}
                      </div>
                          )}
                      </div>
                      </div>
                    
                    </Menu.Item>
                  </div> 
                    </div>
                  ) : null}
                </div> 
                { (this.state.collapsed ===true || (this.state.glofriskassesmentselected==='cgl')) && (
                <div class="modalwindow">
                    <div
                    as="div"

                    className="modalheader"
                    style={{ textAlign: "left" }}
                  >
                    <div style={{ display: "flex" }}>Glacial Lake Size (ha)
                      <div style={{ width: "10%", opacity: "1.0",padding:"0px 0px 0px 0px "}}>
                    
                </div>
                
                </div></div>
                
                <Sliderbar 
                      handleChange_area={ this.handleChange_area}
                      scaleValues_area={this.scaleValues_area}
                      scale_area={this.scale_area}
                      value_area={this.state.value_area}
                      min_ar={this.state.min_ar}
                      max_ar={this.state.max_ar}
                      collapsed={this.state.collapsed}
                      collapsed2={this.state.collapsed2}
                      criticalglaciallakeselected={this.state.criticalglaciallakeselected}
                      glofriskassesmentselected={this.state.glofriskassesmentselected}

                    />
                </div>
               ) }   
                {/*<DateSlider {...this.props.sliderOptions} />*/}
                { (this.state.collapsed ===true ||  (this.state.glofriskassesmentselected==='cgl' )) && (
                <div class="modalwindow">
                <div
                as="div"
            
                className="modalheader"
                style={{ textAlign: "left" }}
              >
                <div style={{ display: "flex" }}>  Glacial Lake Elevation (m)
                  <div style={{ width: "10%", opacity: "1.0" ,padding:"0px 0px 0px 10px " }}>
                  
                
            </div>
            </div></div>
              <Sliderbar1  
                handleChangeValue={ this.handleChangeValue}
                  scaleValues={this.scaleValues}
                  scale={this.scale}
                  value={this.state.value}
                  min={this.state.min}
                  max={this.state.max}
                  collapsed={this.state.collapsed}
                  collapsed2={this.state.collapsed2}
                  criticalglaciallakeselected={this.state.criticalglaciallakeselected}
                  glofriskassesmentselected={this.state.glofriskassesmentselected}
               
                />
</div>
                )}


      {/*<DateSlider {...this.props.sliderOptions} />*/}
 


   
     {/*} <Chart_my/> */}
                



           

            {/*       
         <div class="modalbox">
                 
         </div>
         <div class="modalbox">
                   
         </div> */}
            {/* <div class="modalbox">
                    <select onChange={this.ghandleStationChange} value={this.state.gstationselected}>
                        <option value="#">Critical Glacial Lakes</option>
                        {/* {subbasin_system} */}
            {/* </select>
         </div>
         <div class="modalbox">
                    <select onChange={this.ghandleStationChange} value={this.state.gstationselected}>
                        <option value="#">Select Scenario</option> */}
            {/* {subbasin_system} */}
            {/* </select>
         </div> */}



         
            <div class="modalwindow">
              <div
                class="modalheader"
                style={{
                  backgroundColor: colors.final_side,
                  textAlign: "left",
                  color: colors.textcolor,
                }}
              >
                Information
              </div>
              <div class="modalbox">
                Glacial Lake Details <br />
                Source: Mapped from RS-2 LISS-IV satellite data <br />
                Data Period: 2013 to 2021
                <br />
                <ul>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleTechnicalNote}
                  >
                    <a style={{ textDecoration: "underline" }}>
                      Technical Note{" "}
                    </a>
                  </li>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleDisclaimer}
                  >
                    <a style={{ textDecoration: "underline" }}> Disclaimer</a>
                  </li>
                </ul>
              </div>
            </div>
          </Sidebar>

          <Sidebar.Pusher
            dimmed={false}
            style={{ height: window.innerHeight - 260, border: "0px" }}
          >
            <Segment
              basic
              style={{
                width: "100%",
                height: "100%",
                padding: "0px",
                border: "0px",
                flex: 1,
              }}
            >
              <MapView
                india_states_boundary={this.state.india_states_boundary}
                isAllZero={this.state.isAllZero}
                selectedRegion={this.state.selectedRegion}
                
                units={this.state.units}
                yaxis={this.state.yaxis}
                layerselected={this.state.layer}
                visibleGraphPanel_pie={this.state.visibleGraphPanel_pie}
                visibleGraphPanel_pie1={this.state.visibleGraphPanel_pie1}
                setcriticalboundary={this.state.setcriticalboundary}
                
                selectedFactors={this.state.selectedFactors}
                selectedFeatures={this.state.selectedFeatures}

                categories={this.state.categories}
                series={this.state.series}
                series_gl_type={this.state.series_gl_type}
                setLatLng={this.setLatLng}
                setPopupState={this.setPopupState}
                latlngposition={this.state.latlngposition}
                latlng={this.state.latlng}
                markerPosition={[28.613, 77.209]}
                selected={this.state.selectedMenu}
                selectedLayer={this.state.selectedLayer}
                selectedBaseLayer={this.state.selectedBaseLayer}
                visibleLeft={this.state.visible}
                visibleGraphPanel={this.state.visibleGraphPanel}
                visibleGraphPanel1={this.state.visibleGraphPanel1}
                glofriskassesmentselected={this.state.glofriskassesmentselected}

                handleAnimationChange={this.handleAnimationChange}
                handleVisibleGraphPanelOnMapClick={
                  this.handleVisibleGraphPanelOnMapClick
                }
                toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                toggleVisibleGraphPanel1={this.toggleVisibleGraphPanel1}

                toggleVisibleGraphPanel_pie={this.toggleVisibleGraphPanel_pie}
                toggleVisibleGraphPanel_pie1={this.toggleVisibleGraphPanel_pie1}
                collapsed={this.state.collapsed}
                collapsed2={this.state.collapsed2}
                getFeatureInfo={this.getFeatureInfo}
                setStateInfo={this.setStateInfo}
                stateInfo={this.state.stateInfo ? this.state.stateInfo : null}
                setStateInfoStatus={this.setStateInfoStatus}
                setGLLakeBoundary={this.setGLLakeBoundary}
                stateInfoStatus={this.state.stateInfoStatus}
                gllakeInfoStatus={this.gllakeInfoStatus}
                himalayan_boundary={this.state.himalayan_boundary}
                gl_lake_boundary={this.state.gl_lake_boundary}
                critical_glacial_lake_boundary={this.state.critical_glacial_lake_boundary}
                critical_glacial_lake_boundaryall={this.state.critical_glacial_lake_boundaryall}
                isInfoOpen={this.state.isInfoOpen}
                closeInfo={this.closeInfo}
                geojsonadd={this.state.basininfo}
                glacial_lakes={this.state.glacial_lakes}
                glacial_loading={this.state.glacial_loading}
                boundary={this.state.boundary}
                criticalglaciallakeselected={this.state.criticalglaciallakeselected}
                critical_gl_lake_boundary_status={this.state.critical_gl_lake_boundary_status}
                criticalFactorSelected={this.state.criticalFactorSelected}
                criticalFeatureSelected={this.state.criticalfeatureSelected}
                criticalIndSimBasinSelected={this.state.criticalIndSimBasinSelected}
                criticalIndSimLakeSelected={this.state.criticalIndSimLakeSelected}
                criticalIndSimScenarioSelected={this.state.criticalIndSimScenarioSelected}
                criticalIndSimScenarioSelectedRisk={this.state.criticalIndSimScenarioSelectedRisk}

                criticalRiskBasinSelected={this.state.criticalRiskBasinSelected}
                criticalRiskLakeSelected={this.state.criticalRiskLakeSelected}
                legend_SimScenario={this.state.legend_SimScenario}
                InudationLakeSimBoundary={this.state.InudationLakeSimBoundary}
                glofRiskLakeBoundary={this.state.glofRiskLakeBoundary}
                criticalInudationBasinboundary={this.state.criticalInudationBasinboundary}
                criticalRiskBasinboundary={this.state.criticalRiskBasinboundary}
                
              />
         

            </Segment>


           


            

            {this.state.technicalnoteenable || this.state.disclaimerenable ? (
              <Rnd
                style={{ zIndex: "30", background: "white" }}
            size={{ width: this.state.width, height: this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height: ref.style.height,
                    ...position,
                  });
                }}
              >
                {this.state.technicalnoteenable ? (
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogTClose}
                      ></div>
                      Technical Note
                    </div>

                   
                      <div
                        id="divDialog"
                        class="dialog boxshadow"
                        style={{ overflowY: "auto" }}
                      > <div class="dialog_content">
                        <p style={{ textAlign: "justify" }}>
                        Under National Hydrology Project (NHP), NRSC has taken up "Glacial Lake Outburst Flood (GLOF) Risk Assessment of Glacial Lakes in the Himalayan Region of Indian River Basins". Under this, it is proposed to prepare an inventory of glacial lakes, prioritization and selection of critical glacial lakes based on certain characteristics, GLOF modelling and GLOF risk assessment. Glacial lakes of size greater than 0.25 ha are identified and mapped using high resolution satellite data (Resourcesat-2 Linear Imaging Self Scanning sensor-IV MX) in all the three river systems (Indus, Ganga and Brahmaputra) covering Himalayan region. Using multi-criteria, glacial lakes are prioritised and few critical glacial lakes are selected for further detailed analysis. For selected critical glacial lakes, GLOF flood inundation modelling will be carried out using high resolution Digital Elevation/Terrain Model (DEM) for downstream river reach of the lakes. GLOF risk assessment will be carried out using the flood hazard maps by integrating with the vulnerable elements of infrastructure.
                    </p>
                        <p> <span style={{ color: "blue" }}>   Input Datasets Used:</span></p>
                        <p style={{ textAlign: "justify" }}>
                        Resourcesat-2 LISS-IV Satellite Products: 5.8m Multispectral remote sensing from Linear Imaging Self Scanning sensor (LISS-IV) on board Resourcesat-2 is used for delineating the inventory and mapping of glacial lakes in the Himalayan region based manual image interpretation techniques.  
</p>                    <p style={{ textAlign: "justify" }}>
                        High Resolution DTM: High resolution DTM is used for carrying out the GLOF flood inundation modelling for selected critical glacial lakes.


</p>                    <p style={{ textAlign: "justify" }}>
                        High Resolution Satellite Data: High resolution satellite data is used for deriving the infrastructure details and preparing vulnerability maps for selected critical glacial lakes.
</p>                    <p style={{ textAlign: "justify" }}>
                          Meteorological Datasets: Any suitable gridded precipitation data is used for generating different GLOF flood inundation scenarios due to external triggering event like extreme precipitation.
</p>
 <p style={{ textAlign: "justify" }}><span style={{ color: "blue" }}>
GLOF Model Scenarios:</span>
</p>
  <p style={{ textAlign: "justify" }}>
  GLOF flood inundation scenarios for selected critical glacial lakes will be generated considering with and without the external precipitation events.
 
</p>
<p style={{ textAlign: "justify" }}>
About Products:
</p>  <p style={{ textAlign: "justify" }}>
Glacial Lakes: Glacial lakes with extent greater than 0.25 ha were mapped for the catchment areas of Indian river basins of Himalayas.
</p>
<p style={{ textAlign: "justify" }}><span style={{ color: "blue" }}>
Limitation in the current modelling framework:</span></p>
<p style={{ textAlign: "justify" }}>
<ul><li>
The glacial lakes are mapped using one time satellite data sets which depict the status of the lake at that period which may/may not vary over a time period.
</li><li>
Even though satellite data sets acquired are with minimum snow cover and cloud cover extent, still few lakes would not have been mapped owing to the following constraints:
<ul>
<li>
Presence of snow or cloud over the glacial lakes.

</li>
<li>
Glacial lakes under frozen condition.
</li>
<li>
Glacial lakes under mountain shadow
</li>

</ul>
</li>
</ul>
</p>
<p style={{ textAlign: "justify" }}><span style={{ color: "blue" }}>
Utility of Product:</span></p>
<p style={{ textAlign: "justify" }}>
The glacial lake database can be used as an authentic database for periodic monitoring changes in spatial extent (expansion/shrinkage) and formation of new lakes. The glacial lake information is immensely useful for GLOF risk assessment, assisting disaster mitigation planning for Central and State Disaster Management Authorities. 
</p>

<br/><br/>
                      </div>
                    </div>
                    {/* 
    <div class="dialog-statusbar">Ready</div> */}
                  </div>
                ) : this.state.disclaimerenable ? (
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogDClose}
                      ></div>
                      Disclaimer
                    </div>
                    <div
                        id="divDialog"
                        class="dialog boxshadow"
                        style={{ overflowY: "auto" }}
                      >
                    <div class="dialog_content">
                    <p style={{ textAlign: "justify" }}>
                    The glacial lake maps hosted are based on a specific time period satellite data and changes in their areal extent may/may not occur over a time period. NRSC does not guarantee the accuracy of information provided and accepts no responsibility or liability for any consequences arising from the use of such data. NRSC uses several open data resources to derive and publishing glacial lake maps through this website. Neither NRSC nor any other party involved in creating, producing or delivering the product through this website shall be liable for any direct, incidental, consequential, indirect or punitive damages arising out of Users' access to, or use of, the website and the products. User feedback on any errors or inaccuracies will be highly appreciated.
                    </p>
                    <br/>
                    <br/>
                    </div>
                    </div>
                    {/* 
    <div class="dialog-statusbar">Ready</div> */}
                  </div>
                ) : null}
              </Rnd>
            ) : null}
            {console.log('test pos', this.state.x, this.state.y)}

            {this.state.visibleGraphPanel_pie && this.glofriskassesmentselected!=="gis" &&
              this.state.categories !== null ? (
                <Rnd className="chart_glacial"
                  style={{ zIndex: "10", background: "white"}}
                  size={{ width: this.state.width, height: this.state.height }}
                  position={{ x: this.state.x, y: this.state.y }}
                  onDragStop={(e, d) => {
                    this.setState({ x: d.x, y: d.y });
                  }}
                  onResize={(e, direction, ref, delta, position) => {
                    this.setState({
                      width: ref.style.width,
                      height: ref.style.height,
                      ...position,
                    });
                  }}
                >
                  {!this.state.isAllZero ? (
                    
                    <Chart style={{padding:"10px"}}
                      // style={{backgroundColor:"#FFFFFF"}}



                      toggleVisibleGraphPanel={this.toggleVisibleGraphPanel_pie}

                      series={this.state.series}
                      categories={this.state.categories}
                     // units={this.state.units}
                      title={this.state.title}
                      xaxis={this.state.xaxis}
                      yaxis={this.state.yaxis}
                      classname="chart_glacial"
                     
                    />
                  
                  ) : this.state.isAllZero ? (
                    <div id="divDialog" class="dialog boxshadow">
                      <div class="dialog_header">
                        <div
                          class="minimizebox"
                          onClick={this.handleDialogClose}
                        ></div>
                        Note
                    </div>


                      <div class="dialog_content">
                        <h4 style={{ color: "blue" }}>
                          {" "}
                          No Glacial Lakes found in {this.state.selectedRegion}
                        </h4>
                      </div>
          
                    </div>
                    
                    
                  ) : null}
                </Rnd>
              ) : null}
            {this.state.visibleGraphPanel_pie1 &&
              this.state.categories_gl_type !== null ? (
                <Rnd  className="chart_glacialpie"
                  style={{ zIndex: "10", background: "white"}}
                size={{ width: this.state.width1, height: this.state.height1 }}
                  position={{ x: this.state.x1, y: this.state.y1}}
                  onDragStop={(e1, d1) => {
                    this.setState({ x1: d1.x, y1: d1.y });
                  }}
                  onResize={(e1, direction, ref, delta, position) => {
                    this.setState({
                      width1: ref.style.width1,
                      height1: ref.style.height1,
                      ...position,
                    });
                  }}
                >
                  {!this.state.isAllZero ? (

                    <PieChart style={{padding:"10px"}}
                      // style={{backgroundColor:"#FFFFFF"}}
                      series={this.state.series_gl_type}
                      toggleVisibleGraphPanel={this.toggleVisibleGraphPanel_pie1}
                      title={this.state.title_gl_type}

                      categories={this.state.categories_gl_type}
                     
                     
                      //units={this.state.units}
                      //title={this.state.title}
                      //xaxis={this.state.xaxis}
                     //yaxis={this.state.yaxis}
                    />
                  
                  ) : this.state.isAllZero ? (
                    <div id="divDialog" class="dialog boxshadow">
                      <div class="dialog_header">
                        <div
                          class="minimizebox"
                          onClick={this.handleDialogClose1}
                        ></div>
                        Note
                    </div>

                      <div class="dialog_content">
                        <h4 style={{ color: "blue" }}>
                          {" "}
                          No Glacial Lakes found in {this.state.selectedRegion}
                        </h4>
                      </div>
          
                    </div>

                    
                  ) : null}
                </Rnd>
              ) : null}
           

     

          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

export default GMapContainer;
